(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s6-category-banners"] && !Shopify.designMode) return;
  try {
    
  /*
    S6 Category Banners video audio.
    - Videos start muted. When a banner is at least 60% visible its sound fades in.
    - Only one video has sound at a time; leaving the viewport fades the sound out and mutes it.
    - Browsers block unmuting until the user has interacted. In that case the video stays muted
      and a small "Vklopi zvok" button is shown. The same button lets users turn the sound off.
    - Reduced motion: no autoplay and no sound.
  */
  (() => {
    if (window.__s6bVideoAudio) return;

    const THRESHOLD = 0.6;
    const FADE_IN_MS = 700;
    const FADE_OUT_MS = 300;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const ratios = new Map();
    const fades = new WeakMap();
    let active = null;

    const button = (video) => video.closest('.s6b__item')?.querySelector('.s6b__sound');

    const setButton = (video, state) => {
      const btn = button(video);
      if (!btn) return;
      btn.dataset.state = state;
      if (state === 'hidden') {
        btn.hidden = true;
        return;
      }
      const label = state === 'on' ? btn.dataset.labelOff : btn.dataset.labelOn;
      btn.textContent = label;
      btn.setAttribute('aria-label', label);
      btn.hidden = false;
    };

    const cancelFade = (video) => {
      const id = fades.get(video);
      if (id) cancelAnimationFrame(id);
      fades.delete(video);
    };

    const fade = (video, to, ms) =>
      new Promise((resolve) => {
        cancelFade(video);
        const from = video.volume;
        const start = performance.now();
        const step = (now) => {
          const k = Math.min(1, (now - start) / ms);
          try {
            video.volume = from + (to - from) * k;
          } catch (error) {
            /* volume is read-only on some mobile browsers */
          }
          if (k < 1) fades.set(video, requestAnimationFrame(step));
          else {
            fades.delete(video);
            resolve();
          }
        };
        fades.set(video, requestAnimationFrame(step));
      });

    const silence = (video, immediate) => {
      setButton(video, 'hidden');
      if (video.muted) return;
      if (immediate) {
        cancelFade(video);
        video.muted = true;
        return;
      }
      fade(video, 0, FADE_OUT_MS).then(() => {
        video.muted = true;
      });
    };

    const blocked = (video) => {
      cancelFade(video);
      video.muted = true;
      try {
        video.volume = 1;
      } catch (error) {
        /* ignore */
      }
      video.play().catch(() => {});
      setButton(video, 'blocked');
    };

    const unmute = async (video) => {
      cancelFade(video);
      try {
        video.volume = 0;
      } catch (error) {
        /* ignore */
      }
      video.muted = false;
      try {
        await video.play();
      } catch (error) {
        blocked(video);
        return;
      }
      setButton(video, 'on');
      fade(video, 1, FADE_IN_MS);
      /* Some browsers pause the video right after an unmute without a user gesture. */
      setTimeout(() => {
        if (video === active && video.paused && !video.muted) blocked(video);
      }, 250);
    };

    const activate = (video) => {
      if (video.dataset.userMuted === 'true') {
        setButton(video, 'blocked');
        return;
      }
      const activation = navigator.userActivation;
      if (activation && !activation.hasBeenActive) {
        /* No user interaction yet: unmuting would be refused, so offer the button instead. */
        setButton(video, 'blocked');
        return;
      }
      unmute(video);
    };

    const pick = () => {
      let best = null;
      let bestRatio = 0;
      ratios.forEach((ratio, video) => {
        if (!video.isConnected) {
          ratios.delete(video);
          observer.unobserve(video);
          return;
        }
        if (video.classList.contains('s6b__video--silent')) return; /* silent tiles never get sound */
        if (ratio >= THRESHOLD && ratio > bestRatio) {
          best = video;
          bestRatio = ratio;
        }
      });
      return best;
    };

    const update = () => {
      if (document.hidden || reduce.matches) {
        if (active) silence(active, true);
        active = null;
        return;
      }
      const next = pick();
      if (next === active) return;
      if (active) silence(active, false);
      active = next;
      if (active) activate(active);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
          ratios.set(target, intersectionRatio);
          if (isIntersecting) {
            if (!reduce.matches) target.play().catch(() => {});
          } else {
            setTimeout(() => {
              if (!ratios.get(target)) target.pause();
            }, 400);
          }
        });
        update();
      },
      { threshold: [0, 0.25, 0.5, THRESHOLD, 0.75, 1] }
    );

    const scan = (root) => {
      root.querySelectorAll('.s6b__video').forEach((video) => {
        if (reduce.matches) {
          video.removeAttribute('autoplay');
          video.pause();
          video.load();
          return;
        }
        if (ratios.has(video)) return;
        video.muted = true;
        ratios.set(video, 0);
        observer.observe(video);
      });
    };

    const release = (root) => {
      root.querySelectorAll('.s6b__video').forEach((video) => {
        observer.unobserve(video);
        ratios.delete(video);
        cancelFade(video);
        if (active === video) active = null;
      });
    };

    document.addEventListener('click', (event) => {
      const btn = event.target.closest?.('.s6b__sound');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      const video = btn.closest('.s6b__item')?.querySelector('.s6b__video');
      if (!video) return;
      if (btn.dataset.state === 'on') {
        video.dataset.userMuted = 'true';
        fade(video, 0, FADE_OUT_MS).then(() => {
          video.muted = true;
        });
        setButton(video, 'blocked');
      } else {
        video.dataset.userMuted = 'false';
        unmute(video);
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) ratios.forEach((ratio, video) => silence(video, true));
      update();
    });
    window.addEventListener('pagehide', () => ratios.forEach((ratio, video) => silence(video, true)));
    reduce.addEventListener?.('change', update);

    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    document.addEventListener('shopify:section:unload', (event) => release(event.target));

    window.__s6bVideoAudio = { scan };
    scan(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s6-featured-products"] && !Shopify.designMode) return;
  try {
    
  /*
    S6 Product Explorer.
    - "Active" tile = whichever slide's center is closest to the track's own center, recomputed
      on every scroll frame (drag, wheel, touch swipe and the arrows all fire native 'scroll').
    - Arrow clicks find the nearest slide in that direction (simple spatial-navigation scoring),
      not a hardcoded row/column index, so it stays correct regardless of column count changes.
    - Scrolling is done with track.scrollTo(), never scrollIntoView(), so it can only ever move
      this track - it cannot also scroll the page.
  */
  (() => {
    if (window.__s6exExplorer) return;

    const setup = (root) => {
      const track = root.querySelector('[data-s6ex-track]');
      if (!track || track.dataset.s6exReady) return;
      track.dataset.s6exReady = 'true';

      const explorer = track.closest('[data-s6ex]');
      const slides = [...track.querySelectorAll('[data-s6ex-slide]')];
      const counter = explorer.parentElement.querySelector('[data-s6ex-counter]');
      let activeIndex = 0;

      const setActive = (index) => {
        activeIndex = index;
        slides.forEach((slide, i) => slide.classList.toggle('s6ex__slide--active', i === index));
        if (counter) counter.textContent = slides.length ? `${index + 1} / ${slides.length}` : '';
      };

      const updateActive = () => {
        if (!slides.length) return;
        const trackRect = track.getBoundingClientRect();
        const cx = trackRect.left + trackRect.width / 2;
        const cy = trackRect.top + trackRect.height / 2;
        let best = 0;
        let bestDist = Infinity;
        slides.forEach((slide, i) => {
          const r = slide.getBoundingClientRect();
          const dx = r.left + r.width / 2 - cx;
          const dy = r.top + r.height / 2 - cy;
          const dist = dx * dx + dy * dy;
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        setActive(best);
      };

      let ticking = false;
      track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            updateActive();
            ticking = false;
          });
        },
        { passive: true }
      );
      window.addEventListener('resize', updateActive);

      const scrollToSlide = (slide) => {
        const trackRect = track.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const left = track.scrollLeft + (slideRect.left - trackRect.left) - (trackRect.width - slideRect.width) / 2;
        const top = track.scrollTop + (slideRect.top - trackRect.top) - (trackRect.height - slideRect.height) / 2;
        track.scrollTo({ left, top, behavior: 'smooth' });
      };

      /* Center on the first card immediately, with no animation. */
      if (slides.length) {
        const trackRect = track.getBoundingClientRect();
        const slideRect = slides[0].getBoundingClientRect();
        track.scrollLeft += slideRect.left - trackRect.left - (trackRect.width - slideRect.width) / 2;
        track.scrollTop += slideRect.top - trackRect.top - (trackRect.height - slideRect.height) / 2;
        updateActive();
      }

      /* Nearest slide in direction (dx, dy) from the current one, favoring the same row/column. */
      const findNeighbor = (dx, dy) => {
        const current = slides[activeIndex];
        if (!current) return null;
        const cRect = current.getBoundingClientRect();
        const ccx = cRect.left + cRect.width / 2;
        const ccy = cRect.top + cRect.height / 2;
        let best = null;
        let bestScore = Infinity;
        slides.forEach((slide) => {
          if (slide === current) return;
          const r = slide.getBoundingClientRect();
          const vx = r.left + r.width / 2 - ccx;
          const vy = r.top + r.height / 2 - ccy;
          const primary = vx * dx + vy * dy;
          if (primary <= 1) return;
          const perpendicular = Math.abs(vx * dy - vy * dx);
          const score = primary + perpendicular * 2;
          if (score < bestScore) {
            bestScore = score;
            best = slide;
          }
        });
        return best;
      };

      const go = (dx, dy) => {
        const target = findNeighbor(dx, dy);
        if (target) scrollToSlide(target);
      };

      explorer.querySelectorAll('[data-s6ex-nav]').forEach((button) => {
        const [dx, dy] = button.dataset.s6exNav.split(',').map(Number);
        button.addEventListener('click', () => go(dx, dy));
      });

      track.addEventListener('keydown', (event) => {
        const map = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
        const delta = map[event.key];
        if (!delta) return;
        event.preventDefault();
        go(delta[0], delta[1]);
      });

      /* Mouse click-drag-to-pan (touch/trackpad/wheel already pan natively). */
      let dragging = false;
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      let startTop = 0;
      let moved = false;

      track.addEventListener('mousedown', (event) => {
        dragging = true;
        moved = false;
        track.classList.add('s6ex__track--dragging');
        startX = event.pageX;
        startY = event.pageY;
        startLeft = track.scrollLeft;
        startTop = track.scrollTop;
      });

      window.addEventListener('mousemove', (event) => {
        if (!dragging) return;
        const dx = event.pageX - startX;
        const dy = event.pageY - startY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
        track.scrollLeft = startLeft - dx;
        track.scrollTop = startTop - dy;
      });

      const endDrag = () => {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('s6ex__track--dragging');
      };
      window.addEventListener('mouseup', endDrag);
      track.addEventListener('mouseleave', endDrag);

      track.addEventListener(
        'click',
        (event) => {
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
            moved = false;
          }
        },
        true
      );
    };

    const scan = (root) => root.querySelectorAll('[data-s6ex]').forEach((explorer) => setup(explorer));

    document.addEventListener('shopify:section:load', (event) => scan(event.target));

    window.__s6exExplorer = { scan };
    scan(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s6-ogledala-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__s6ohHub) return;

    const init = (root) => {
      if (root.dataset.s6ohReady) return;
      root.dataset.s6ohReady = 'true';

      const grid = root.querySelector('[data-s6oh-grid]');
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('[data-s6oh-card]'));
      const empty = root.querySelector('[data-s6oh-empty]');
      const state = { shape: null, room: null, makeup: null, size: null, led: null, frame: null, light: null, tab: 'all' };
      // Separate state of the lower "Priljubljena ogledala" browse section - never shared with `state`.
      const browse = { tab: 'all', shape: null, led: null, frame: null, makeup: null };
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // V6: reassigned further down once the hero elements are located; a no-op placeholder here
      // means the filter/reset handlers above can reference it unconditionally.
      let applyShapeHero = () => {};

      const sizeInRange = (value, range) => {
        if (!value) return false;
        const [min, max] = range.split('-').map(Number);
        return value >= min && value <= max;
      };

      // V17 (instant filter results): `updateInstant` is called from inside the existing `apply()`
      // below with the exact SAME `visibleCards`/`visible` it already computes for the main grid -
      // there is no separate filtering pass and no second state object, only this one extra
      // presentation step reading `state` (already the single source of truth) after every filter
      // change. Preview cards are built by cloning trimmed nodes off the real, already-rendered
      // `[data-s6oh-card]` elements (image/title/spec/price), never a second product data source.
      const instant = root.querySelector('[data-s6oh-instant]');
      const instantSummary = root.querySelector('[data-s6oh-instant-summary]');
      const instantCount = root.querySelector('[data-s6oh-instant-count]');
      const instantPreviewLabel = root.querySelector('[data-s6oh-instant-preview-label]');
      const instantTrack = root.querySelector('[data-s6oh-instant-track]');
      const instantEmpty = root.querySelector('[data-s6oh-instant-empty]');
      const instantCta = root.querySelector('[data-s6oh-instant-cta]');
      const instantCtaLabel = instantCta ? instantCta.querySelector('[data-s6oh-instant-cta-label]') : null;
      // V34: shared by the real CTA button and the optional "+N" cue (section 13) - both must
      // behave identically (keep filters, smooth-scroll, never reset state), so this is the one
      // place that behavior lives rather than two near-duplicate handlers.
      const scrollToProducts = (e) => {
        if (e) e.preventDefault();
        const productsEl = root.querySelector('#s6oh-products');
        if (productsEl) productsEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      };
      // The configurator now sits above the editorial cards; these two want the full filtered grid.
      const scrollToGrid = (e) => {
        if (e) e.preventDefault();
        const gridEl = root.querySelector('#s6oh-grid') || root.querySelector('#s6oh-products');
        if (gridEl) gridEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      };
      let I18N = {};
      try { I18N = JSON.parse(root.dataset.s6ohI18n || '{}'); } catch (e) { I18N = {}; }
      const INSTANT_SHAPE_LABELS = I18N.shape || {};
      const INSTANT_ROOM_LABELS = I18N.room || {};
      const INSTANT_LED_LABELS = I18N.led || {};
      const INSTANT_FRAME_LABELS = I18N.frame || {};
      const INSTANT_SIZE_LABELS = I18N.size || {};
      const instantSizeLabel = (range) => {
        const [min, max] = range.split('-').map(Number);
        if (min === max) return `Ø ${min} cm`;
        return INSTANT_SIZE_LABELS[range] || `${min}–${max} cm`;
      };
      const INSTANT_PREVIEW_MAX = 6;
      let instantFadeTimer = null;
      let instantExpanded = false; // "show all" expands the exact-results list in place
      const buildInstantCard = (card) => {
        const link = card.querySelector('.s6oh__card-link');
        const img = card.querySelector('.s6oh__card-img--primary');
        const title = card.querySelector('.s6oh__card-title');
        const spec = card.querySelector('.s6oh__card-spec');
        const price = card.querySelector('.s6oh__card-price');
        const badge = card.querySelector('.s6oh__badge');
        if (!link || !img || !title || !price) return null;

        const a = document.createElement('a');
        a.className = 's6oh__instant-card';
        a.href = link.getAttribute('href');

        const media = document.createElement('span');
        media.className = 's6oh__instant-card-media';
        media.appendChild(img.cloneNode(true));
        if (badge) media.appendChild(badge.cloneNode(true));
        a.appendChild(media);

        // Display only (the Shopify title is never changed): model/name line (max 2 lines) + a separate, stronger dimension line.
        const DIM_RE = /(?:(?:fi|Ø|⌀)\s*)?\d+(?:[.,]\d+)?(?:\s*[x×]\s*\d+(?:[.,]\d+)?)*\s*cm/i;
        const rawTitle = title.textContent.trim().replace(/\s+/g, ' ');
        let nameText = rawTitle;
        let dimText = '';
        const dm = DIM_RE.exec(rawTitle);
        if (dm) {
          nameText = (rawTitle.slice(0, dm.index) + rawTitle.slice(dm.index + dm[0].length))
            .replace(new RegExp('\\s*/\\s*' + DIM_RE.source, 'gi'), '')
            .replace(/\s*,\s*,/g, ',')
            .replace(/\s+,/g, ',')
            .replace(/[\s,]+$/, '')
            .replace(/\s{2,}/g, ' ')
            .trim();
          dimText = dm[0].replace(/\s*[x×]\s*/gi, ' × ').replace(/^fi\s*/i, 'Ø ').replace(/^⌀\s*/, 'Ø ').replace(/\s*cm$/i, ' cm').replace(/\s+/g, ' ').trim();
        }
        const titleEl = document.createElement('span');
        titleEl.className = 's6oh__instant-card-title';
        titleEl.textContent = nameText;
        a.appendChild(titleEl);

        if (dimText) {
          const dimEl = document.createElement('span');
          dimEl.className = 's6oh__instant-card-dim';
          dimEl.textContent = dimText;
          a.appendChild(dimEl);
        } else if (spec) {
          const specEl = document.createElement('span');
          specEl.className = 's6oh__instant-card-spec';
          specEl.textContent = spec.textContent.trim();
          a.appendChild(specEl);
        }

        const priceEl = document.createElement('span');
        priceEl.className = 's6oh__instant-card-price';
        priceEl.innerHTML = price.innerHTML;
        a.appendChild(priceEl);

        return a;
      };
      // ---- Alternatives (only when there is NO exact match) ----
      const CFG = I18N.cfg || {};
      const altEl = root.querySelector('[data-s6oh-alt]');
      const altTrack = root.querySelector('[data-s6oh-alt-track]');
      const fillInstead = (g, w) => String(CFG.instead || '__G__ / __W__').replace('__G__', g).replace('__W__', w);
      const lightsOf = (d) => (d.light || '').split(' ').filter(Boolean);
      const sizeText = (d) => (d.shape === 'okrogla' ? `Ø ${Number(d.size)} cm` : `${Number(d.size)} cm`);
      // Distance of a card from the selected size (0 = inside the range / same diameter).
      const sizeDistance = (d, s) => {
        if (!s.size) return 0;
        const [lo, hi] = s.size.split('-').map(Number);
        const v = Number(d.size);
        if (lo === hi) return d.shape === 'okrogla' ? Math.abs(v - lo) : 500 + Math.abs(v - lo);
        if (v >= lo && v <= hi) return 0;
        return Math.min(Math.abs(v - lo), hi >= 9999 ? 1e6 : Math.abs(v - hi));
      };
      // Which selected filters does this card NOT satisfy, and what does it have instead?
      const mismatches = (d, s) => {
        const out = [];
        if (s.shape && d.shape !== s.shape) out.push({ k: 'shape', got: INSTANT_SHAPE_LABELS[d.shape] || (d.makeup === 'true' ? (I18N.makeup || 'Make-up') : (CFG.lbl_shape || '')), want: CFG['gen_shape_' + s.shape] || INSTANT_SHAPE_LABELS[s.shape] || s.shape });
        if (s.makeup && d.makeup !== 'true') out.push({ k: 'makeup', got: CFG.plain_mirror || '', want: CFG.gen_makeup || (I18N.makeup || 'Make-up') });
        if (s.size && !sizeInRange(Number(d.size), s.size)) out.push({ k: 'size', got: sizeText(d), want: instantSizeLabel(s.size) });
        if (s.light && !lightsOf(d).includes(s.light)) out.push({ k: 'light', got: lightsOf(d)[0] ? (CFG['light_' + lightsOf(d)[0]] || lightsOf(d)[0]) : (CFG.other_light || ''), want: CFG['gen_light_' + s.light] || s.light });
        if (s.frame && d.frame !== s.frame) out.push({ k: 'frame', got: d.frame ? (INSTANT_FRAME_LABELS[d.frame] || d.frame) : (CFG.other_frame || ''), want: CFG['gen_frame_' + (s.frame === 'brez-okvirja' ? 'brez' : s.frame)] || INSTANT_FRAME_LABELS[s.frame] || s.frame });
        if (s.room && !(d.room || '').split(' ').includes(s.room)) {
          const r0 = (d.room || '').split(' ').filter(Boolean)[0];
          out.push({ k: 'room', got: r0 ? (INSTANT_ROOM_LABELS[r0] || r0) : (CFG.lbl_room || ''), want: CFG['gen_room_' + s.room] || INSTANT_ROOM_LABELS[s.room] || s.room });
        }
        if (s.led && d.led !== s.led) out.push({ k: 'led', got: INSTANT_LED_LABELS[d.led] || d.led, want: CFG['gen_led_' + (s.led === 'led' ? 'led' : 'brez')] || INSTANT_LED_LABELS[s.led] || s.led });
        return out;
      };
      const diffLines = (m) => m.slice(0, 3).map((x) => {
        const phrase = fillInstead(x.got, x.want);
        if (x.k === 'shape') return `${CFG.lbl_shape || ''}: ${phrase}`;
        if (x.k === 'size') return `${CFG.lbl_size || ''}: ${phrase}`;
        if (x.k === 'room') return `${CFG.lbl_room || ''}: ${phrase}`;
        return phrase;
      });
      // Nearest first: same shape > same/nearest size > same lighting > same frame > everything else.
      const rankAlternatives = (s) => cards
        .filter((c) => !c.hasAttribute('data-dup'))
        .map((card, i) => {
          const m = mismatches(card.dataset, s);
          const has = (k) => m.some((x) => x.k === k);
          return { card, m, i, score: [has('shape') || has('makeup') ? 1 : 0, sizeDistance(card.dataset, s), has('light') ? 1 : 0, has('frame') ? 1 : 0, m.filter((x) => !['shape', 'makeup', 'size', 'light', 'frame'].includes(x.k)).length] };
        })
        .sort((a, b) => {
          for (let k = 0; k < a.score.length; k += 1) if (a.score[k] !== b.score[k]) return a.score[k] - b.score[k];
          return a.i - b.i;
        });

      const updateInstant = (visibleCards, visibleCount) => {
        if (!instant) return;
        const anyFilterActive = Boolean(state.shape || state.room || state.makeup || state.size || state.led || state.frame || state.light);
        if (!anyFilterActive) {
          instant.hidden = true;
          if (altEl) altEl.hidden = true;
          return;
        }
        instant.hidden = false;

        if (instantSummary) {
          const parts = [];
          if (state.shape) parts.push(INSTANT_SHAPE_LABELS[state.shape] || state.shape);
          if (state.size) parts.push(instantSizeLabel(state.size));
          if (state.room) parts.push(INSTANT_ROOM_LABELS[state.room] || state.room);
          if (state.makeup) parts.push(I18N.makeup || 'Make-up');
          if (state.led) parts.push(INSTANT_LED_LABELS[state.led] || state.led);
          if (state.frame) parts.push(INSTANT_FRAME_LABELS[state.frame] || state.frame);
          if (state.light) {
            const lightChip = root.querySelector(`[data-s6oh-filter="light"][data-value="${state.light}"]`);
            parts.push(lightChip ? lightChip.textContent.trim() : state.light);
          }
          instantSummary.textContent = parts.join(' • ');
        }
        if (instantCount) {
          if (visibleCount === 1) instantCount.textContent = I18N.countOne || '';
          else if (visibleCount === 2) instantCount.textContent = I18N.countTwo || '';
          else if (visibleCount > 0) instantCount.textContent = (I18N.countOther || '').replace('__N__', visibleCount);
          else instantCount.textContent = '';
        }
        if (instantPreviewLabel) {
          if (!instantExpanded && visibleCount > INSTANT_PREVIEW_MAX) {
            instantPreviewLabel.textContent = (I18N.showingFirst || '').replace('__TOTAL__', visibleCount);
            instantPreviewLabel.hidden = false;
          } else {
            instantPreviewLabel.textContent = '';
            instantPreviewLabel.hidden = true;
          }
        }
        // "Show all" only matters when the preview row is truncated; it expands the list in place.
        if (instantCtaLabel) instantCtaLabel.textContent = instantExpanded ? (CFG.show_less || '') : (I18N.showCount || '').replace('__N__', visibleCount);
        if (instantCta) instantCta.hidden = visibleCount <= INSTANT_PREVIEW_MAX;
        if (instantEmpty) instantEmpty.hidden = visibleCount > 0;

        // No exact match: keep the selection untouched, say so, and offer clearly-labelled alternatives.
        if (altEl && altTrack) {
          altTrack.textContent = '';
          if (visibleCount === 0) {
            const ranked = rankAlternatives(state).slice(0, INSTANT_PREVIEW_MAX);
            ranked.forEach((r) => {
              const el = buildInstantCard(r.card);
              if (!el) return;
              el.classList.add('s6oh__instant-card--alt');
              const media = el.querySelector('.s6oh__instant-card-media');
              if (media) {
                const badge = document.createElement('span');
                badge.className = 's6oh__alt-badge';
                badge.textContent = CFG.alt_badge || '';
                media.appendChild(badge);
              }
              const diff = document.createElement('span');
              diff.className = 's6oh__alt-diff';
              diffLines(r.m).forEach((t) => {
                const line = document.createElement('span');
                line.textContent = t;
                diff.appendChild(line);
              });
              const priceEl = el.querySelector('.s6oh__instant-card-price');
              el.insertBefore(diff, priceEl || null);
              altTrack.appendChild(el);
            });
            altEl.hidden = ranked.length === 0;
          } else {
            altEl.hidden = true;
          }
        }

        if (!instantTrack) return;
        clearTimeout(instantFadeTimer);
        const rebuild = () => {
          instantTrack.textContent = '';
          instantTrack.classList.toggle('s6oh__instant-track--all', instantExpanded);
          const list = instantExpanded ? visibleCards : visibleCards.slice(0, INSTANT_PREVIEW_MAX);
          list.forEach((card) => {
            const el = buildInstantCard(card);
            if (el) instantTrack.appendChild(el);
          });
          // "+N" tile: only when the row is truncated; same expand-in-place behaviour as the CTA.
          if (!instantExpanded && visibleCount > INSTANT_PREVIEW_MAX) {
            const remaining = visibleCount - INSTANT_PREVIEW_MAX;
            const more = document.createElement('a');
            more.className = 's6oh__instant-more';
            more.href = '#s6oh-products';
            const moreCount = document.createElement('span');
            moreCount.className = 's6oh__instant-more-count';
            moreCount.textContent = `+${remaining}`;
            const moreLabel = document.createElement('span');
            moreLabel.className = 's6oh__instant-more-label';
            moreLabel.textContent = I18N.more || '';
            more.appendChild(moreCount);
            more.appendChild(moreLabel);
            more.addEventListener('click', toggleExpanded);
            instantTrack.appendChild(more);
          }
          instantTrack.classList.remove('s6oh__instant-track--fading');
        };
        if (prefersReduced || instantExpanded) {
          rebuild();
        } else {
          instantTrack.classList.add('s6oh__instant-track--fading');
          instantFadeTimer = setTimeout(rebuild, 160);
        }
      };

      // Filtering itself is always instant (the `ok` check below never waits on anything) - only
      // the VISUAL removal of a now-non-matching card is softened with a short fade, so results
      // never flash abruptly. A newly-matching card fades back in the same way.
      const FADE_MS = prefersReduced ? 0 : 220;
      const fadeTimers = new WeakMap();
      // V35 (guide modal): the per-card match check is the ONE matching rule on this page. It
      // used to live inline in `apply()`; it's a named function now only so the guide modal's live
      // "Priporočamo za vas" preview can run the identical rule against its draft selection -
      // `apply()` still calls it with the real `state`, unchanged in behavior.
      const cardMatches = (d, s) => {
        if (s.shape && d.shape !== s.shape) return false;
        if (s.room && !(d.room || '').split(' ').includes(s.room)) return false;
        if (s.makeup && d.makeup !== 'true') return false;
        if (s.size && !sizeInRange(Number(d.size), s.size)) return false;
        if (s.led && d.led !== s.led) return false;
        if (s.frame && d.frame !== s.frame) return false;
        if (s.light && !(d.light || '').split(' ').includes(s.light)) return false;
        return true;
      };
      // Lower "Priljubljena ogledala" grid: filtered ONLY by its own `browse` state.
      const browseMatches = (d) => {
        if (browse.shape && d.shape !== browse.shape) return false;
        if (browse.makeup && d.makeup !== 'true') return false;
        if (browse.led && d.led !== browse.led) return false;
        if (browse.frame && d.frame !== browse.frame) return false;
        if (browse.tab === 'new' && d.new !== 'true') return false;
        if (browse.tab === 'sale' && d.sale !== 'true') return false;
        if (browse.tab === 'bestseller' && d.bestseller !== 'true') return false;
        return true;
      };
      const applyGrid = () => {
        let visible = 0;
        cards.forEach((card) => {
          const ok = browseMatches(card.dataset);
          // `data-dup` cards are shown/hidden like any other but counted only once.
          if (ok && !card.hasAttribute('data-dup')) visible += 1;

          clearTimeout(fadeTimers.get(card));
          if (ok && card.hidden) {
            card.hidden = false;
            card.classList.add('s6oh__card--entering');
            requestAnimationFrame(() => requestAnimationFrame(() => card.classList.remove('s6oh__card--entering')));
          } else if (!ok && !card.hidden) {
            card.classList.add('s6oh__card--leaving');
            fadeTimers.set(card, setTimeout(() => {
              card.hidden = true;
              card.classList.remove('s6oh__card--leaving');
            }, FADE_MS));
          }
        });
        if (empty) empty.hidden = visible > 0;
      };
      // Configurator: exact matches for ALL selected filters (alternatives are handled in updateInstant).
      const applyConfigurator = () => {
        const exact = [];
        cards.forEach((card) => {
          if (!card.hasAttribute('data-dup') && cardMatches(card.dataset, state)) exact.push(card);
        });
        updateInstant(exact, exact.length);
      };
      const apply = () => {
        instantExpanded = false;
        applyGrid();
        applyConfigurator();
      };
      const toggleExpanded = (e) => {
        if (e) e.preventDefault();
        instantExpanded = !instantExpanded;
        applyConfigurator();
      };

      // Tab counts (computed once from real card data, not fabricated).
      const counts = { all: cards.length, new: 0, sale: 0, bestseller: 0 };
      cards.forEach((c) => {
        if (c.dataset.new === 'true') counts.new += 1;
        if (c.dataset.sale === 'true') counts.sale += 1;
        if (c.dataset.bestseller === 'true') counts.bestseller += 1;
      });
      root.querySelectorAll('[data-s6oh-count]').forEach((el) => {
        const key = el.dataset.s6ohCount;
        el.textContent = `(${counts[key] || 0})`;
      });

      // ======================= CONFIGURATOR STATE RULES (single place) =======================
      // `state` drives ONLY the configurator (filter bar + instant results + guide). The lower
      // "Priljubljena ogledala" section has its own, separate `browse` state (see below) - nothing
      // is shared between the two, so no hidden filter can leak from one into the other.
      const isDiameter = (v) => {
        if (!v) return false;
        const [a, b] = String(v).split('-').map(Number);
        return a === b;
      };
      // `s` is the page `state` or the guide modal's `draft`. `changed` = the group the visitor just touched.
      const normalizeState = (s, changed) => {
        // Make-up is a shape-like choice: exclusive with the shapes.
        if (changed === 'makeup' && s.makeup) s.shape = null;
        if (changed === 'shape' && s.shape) s.makeup = null;
        // A size belongs to ONE shape: a diameter (Ø) only to Okrogla, a rectangular range only to
        // Pravokotna / kvadratna. Any other shape - or no shape - clears it completely (real state,
        // not just hidden chips).
        if (s.size) {
          if (isDiameter(s.size)) { if (s.shape !== 'okrogla') s.size = null; }
          else if (s.shape !== 'pravokotna') s.size = null;
        }
        // Lighting type only exists on LED mirrors.
        if (changed === 'led' && s.led !== 'led') s.light = null;
        if (changed === 'light' && s.light) s.led = 'led';
        if (s.light && s.led !== 'led') s.led = 'led';
      };
      const syncChips = () => {
        root.querySelectorAll('[data-s6oh-filter]').forEach((b) => {
          const on = state[b.dataset.s6ohFilter] === b.dataset.value;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      };

      root.querySelectorAll('[data-s6oh-filter]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.dataset.s6ohFilter;
          const value = btn.dataset.value;
          const next = state[group] === value ? null : value;
          state[group] = next;
          // A round-diameter chip / rectangular size chip carries `data-s6oh-implies-shape` -
          // activating it (never on de-activation) also selects that shape.
          const impliedShape = btn.dataset.s6ohImpliesShape;
          if (impliedShape && next) { state.shape = impliedShape; state.makeup = null; }
          normalizeState(state, group);
          syncChips();
          apply();
          applyShapeHero(state.shape || null);
          // V8: the shape-discovery cards use this same handler; this attribute only adds "also scroll to the configurator".
          if (btn.hasAttribute('data-s6oh-scroll-to-products') && next) {
            const productsEl = root.querySelector('#s6oh-products');
            if (productsEl) productsEl.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
          }
        });
      });

      // ======================= LOWER "PRILJUBLJENA OGLEDALA" BROWSE STATE (independent) =======================
      const syncBrowse = () => {
        root.querySelectorAll('[data-s6oh-browse]').forEach((b) => {
          const on = browse[b.dataset.s6ohBrowse] === b.dataset.value;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-s6oh-btab]').forEach((t) => {
          const on = t.dataset.s6ohBtab === browse.tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
      };
      root.querySelectorAll('[data-s6oh-browse]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const g = btn.dataset.s6ohBrowse;
          const v = btn.dataset.value;
          browse[g] = browse[g] === v ? null : v;
          if (g === 'makeup' && browse.makeup) browse.shape = null;
          if (g === 'shape' && browse.shape) browse.makeup = null;
          syncBrowse();
          applyGrid();
        });
      });
      root.querySelectorAll('[data-s6oh-btab]').forEach((tab) => {
        tab.addEventListener('click', () => {
          browse.tab = tab.dataset.s6ohBtab;
          syncBrowse();
          applyGrid();
        });
      });
      const browseClearBtn = root.querySelector('[data-s6oh-browse-clear]');
      if (browseClearBtn) {
        browseClearBtn.addEventListener('click', () => {
          browse.tab = 'all'; browse.shape = null; browse.led = null; browse.frame = null; browse.makeup = null;
          syncBrowse();
          applyGrid();
        });
      }

      // One reset implementation, two triggers (filter-bar reset chip + the empty-state button). Configurator only.
      const resetAll = () => {
        Object.keys(state).forEach((k) => { if (k !== 'tab') state[k] = null; });
        syncChips();
        apply();
        applyShapeHero(null);
      };
      const resetBtn = root.querySelector('[data-s6oh-reset]');
      if (resetBtn) resetBtn.addEventListener('click', resetAll);
      const instantClearBtn = root.querySelector('[data-s6oh-instant-clear]');
      if (instantClearBtn) instantClearBtn.addEventListener('click', resetAll);
      // "Show all" / "+N": expand the results list in place (the lower grid is a separate browse section).
      if (instantCta) instantCta.addEventListener('click', toggleExpanded);

      // ---- V35: "Kako izbrati pravo ogledalo?" guide modal ----
      // Tab 1 edits a modal-local DRAFT (same keys as `state`); nothing on the page changes until
      // "Prikaži primerna ogledala" copies the draft into the one existing `state`, syncs the page's
      // own filter chips and runs the existing `apply()`. The live preview reuses `cardMatches()`
      // (the grid's own rule) and `buildInstantCard()` (the instant-results card builder).
      const guide = root.querySelector('[data-s6oh-guide]');
      const guideOpenBtns = Array.from(root.querySelectorAll('[data-s6oh-guide-open]'));
      if (guide && guideOpenBtns.length) {
        const gDialog = guide.querySelector('[data-s6oh-guide-dialog]');
        const gCloseBtn = guide.querySelector('.s6oh-guide__close');
        const gTabs = Array.from(guide.querySelectorAll('[data-s6oh-guide-tab]'));
        const gPanels = Array.from(guide.querySelectorAll('[data-s6oh-guide-panel]'));
        const gChips = Array.from(guide.querySelectorAll('[data-s6oh-guide-pick]'));
        const gSummary = guide.querySelector('[data-s6oh-guide-summary]');
        const gCount = guide.querySelector('[data-s6oh-guide-count]');
        const gReco = guide.querySelector('[data-s6oh-guide-reco]');
        const gRecoTrack = guide.querySelector('[data-s6oh-guide-reco-track]');
        const gApply = guide.querySelector('[data-s6oh-guide-apply]');
        const gClear = guide.querySelector('[data-s6oh-guide-clear]');
        const GUIDE_KEYS = ['shape', 'room', 'makeup', 'size', 'led', 'light', 'frame'];
        const GUIDE_RECO_MAX = 6;
        const draft = { shape: null, room: null, makeup: null, size: null, led: null, light: null, frame: null, tab: 'all' };
        let guideLastFocused = null;

        const guideCountText = (n) => {
          if (n === 0) return I18N.emptyZero || '';
          if (n === 1) return I18N.countOne || '';
          if (n === 2) return I18N.countTwo || '';
          return (I18N.countOther || '').replace('__N__', n);
        };

        const renderDraft = () => {
          // Lighting type (front / ambient / edge) only exists for LED mirrors: the chips stay
          // disabled until "LED osvetlitev" is chosen, and any pick is dropped if LED is switched off.
          if (draft.led !== 'led') draft.light = null;
          const lightOn = draft.led === 'led';
          const lightHint = guide.querySelector('[data-s6oh-guide-light-hint]');
          if (lightHint) lightHint.hidden = lightOn;
          gChips.forEach((chip) => {
            const g = chip.dataset.s6ohGuidePick;
            if (g === 'light') chip.disabled = !lightOn;
            chip.classList.toggle('is-active', draft[g] === chip.dataset.value);
            chip.setAttribute('aria-pressed', draft[g] === chip.dataset.value ? 'true' : 'false');
          });
          const parts = [];
          if (draft.room) parts.push(INSTANT_ROOM_LABELS[draft.room] || draft.room);
          if (draft.makeup) parts.push(I18N.makeup || 'Make-up');
          if (draft.shape) parts.push(INSTANT_SHAPE_LABELS[draft.shape] || draft.shape);
          if (draft.size) parts.push(instantSizeLabel(draft.size));
          if (draft.led) parts.push(INSTANT_LED_LABELS[draft.led] || draft.led);
          if (draft.light) {
            const lightChip = guide.querySelector(`[data-s6oh-guide-pick="light"][data-value="${draft.light}"]`);
            parts.push(lightChip ? lightChip.textContent.trim() : draft.light);
          }
          if (draft.frame) parts.push(INSTANT_FRAME_LABELS[draft.frame] || draft.frame);
          const any = parts.length > 0;
          if (gSummary) gSummary.textContent = any ? parts.join(' • ') : (I18N.nothingSelected || '');
          const matches = any ? cards.filter((c) => cardMatches(c.dataset, draft)) : [];
          if (gCount) gCount.textContent = any ? guideCountText(matches.length) : '';
          if (gReco && gRecoTrack) {
            gRecoTrack.textContent = '';
            matches.slice(0, GUIDE_RECO_MAX).forEach((card) => {
              const el = buildInstantCard(card);
              if (el) gRecoTrack.appendChild(el);
            });
            gReco.hidden = !(any && matches.length > 0);
          }
          if (gApply) gApply.disabled = !any;
        };

        gChips.forEach((chip) => {
          chip.addEventListener('click', () => {
            const g = chip.dataset.s6ohGuidePick;
            const value = chip.dataset.value;
            const next = draft[g] === value ? null : value;
            draft[g] = next;
            // Same rules as the page's own chips: a Ø / rectangular size implies its shape; leaving the shape clears the size.
            if (next && chip.dataset.impliesShape) { draft.shape = chip.dataset.impliesShape; draft.makeup = null; }
            normalizeState(draft, g);
            renderDraft();
          });
        });

        if (gClear) {
          gClear.addEventListener('click', () => {
            GUIDE_KEYS.forEach((k) => { draft[k] = null; });
            renderDraft();
          });
        }

        const activateTab = (key, focusTab) => {
          gTabs.forEach((t) => {
            const on = t.dataset.s6ohGuideTab === key;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.setAttribute('tabindex', on ? '0' : '-1');
            if (on && focusTab) t.focus();
          });
          gPanels.forEach((p) => {
            const on = p.dataset.s6ohGuidePanel === key;
            p.classList.toggle('is-active', on);
            p.hidden = !on;
          });
        };
        gTabs.forEach((t, i) => {
          t.addEventListener('click', () => activateTab(t.dataset.s6ohGuideTab, false));
          t.addEventListener('keydown', (e) => {
            let idx = null;
            if (e.key === 'ArrowRight') idx = (i + 1) % gTabs.length;
            else if (e.key === 'ArrowLeft') idx = (i - 1 + gTabs.length) % gTabs.length;
            else if (e.key === 'Home') idx = 0;
            else if (e.key === 'End') idx = gTabs.length - 1;
            if (idx === null) return;
            e.preventDefault();
            activateTab(gTabs[idx].dataset.s6ohGuideTab, true);
          });
        });

        const guideFocusables = () => Array.from(gDialog.querySelectorAll('button:not([disabled]):not([tabindex="-1"]), a[href], [tabindex="0"]')).filter((el) => el.offsetParent !== null);
        const onGuideKeydown = (event) => {
          if (event.key === 'Escape') { closeGuide(); return; }
          if (event.key !== 'Tab') return;
          const f = guideFocusables();
          if (!f.length) return;
          const first = f[0];
          const last = f[f.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        };

        function openGuide() {
          guideLastFocused = document.activeElement;
          // Start from what the page already has filtered, so the guide never contradicts it.
          GUIDE_KEYS.forEach((k) => { draft[k] = state[k]; });
          // A lighting type picked on the page's own bar implies LED mirrors.
          if (draft.light) draft.led = 'led';
          renderDraft();
          activateTab('quick', false);
          guide.hidden = false;
          document.body.style.overflow = 'hidden';
          const show = () => { guide.classList.add('is-open'); (gCloseBtn || gDialog).focus(); };
          if (prefersReduced) show();
          else requestAnimationFrame(() => requestAnimationFrame(show));
          document.addEventListener('keydown', onGuideKeydown);
        }

        function closeGuide() {
          guide.classList.remove('is-open');
          document.removeEventListener('keydown', onGuideKeydown);
          document.body.style.overflow = '';
          const finish = () => { guide.hidden = true; };
          if (prefersReduced) finish();
          else setTimeout(finish, 280);
          if (guideLastFocused && guideLastFocused.focus) guideLastFocused.focus();
        }

        if (gApply) {
          gApply.addEventListener('click', () => {
            GUIDE_KEYS.forEach((k) => { state[k] = draft[k]; });
            normalizeState(state, 'shape');
            syncChips();
            apply();
            applyShapeHero(state.shape || null);
            closeGuide();
            scrollToProducts();
          });
        }

        guideOpenBtns.forEach((btn) => btn.addEventListener('click', openGuide));
        guide.querySelectorAll('[data-s6oh-guide-close]').forEach((el) => el.addEventListener('click', closeGuide));
        gDialog.setAttribute('tabindex', '-1');
        renderDraft();
      }

      const moreBtn = root.querySelector('[data-s6oh-more-filters]');
      const extra = root.querySelector('[data-s6oh-extra-filters]');
      if (moreBtn && extra) {
        moreBtn.addEventListener('click', () => {
          const open = extra.hidden;
          extra.hidden = !open;
          moreBtn.setAttribute('aria-expanded', open);
        });
      }

      const sortSelect = root.querySelector('[data-s6oh-sort]');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => {
          const mode = sortSelect.value;
          const sorted = [...cards];
          if (mode === 'price-asc') sorted.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
          else if (mode === 'price-desc') sorted.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
          sorted.forEach((card) => grid.appendChild(card));
          // V16 (bento grid): a curated large-feature layout only makes sense in the curated
          // default order - once actively price-sorted, `.s6oh__grid--sorted` (CSS) resets every
          // feature/medium/editorial span back to a plain 1x1 tile so nothing looks broken.
          grid.classList.toggle('s6oh__grid--sorted', mode !== 'default');
        });
      }

      // ---------------------------------------------------------------
      // V5: restrained scroll reveal. Classes are only ever added here -
      // if this script never runs, nothing gets `.s6oh-reveal` and every
      // element stays at its normal opacity/position (see the CSS rule).
      // ---------------------------------------------------------------
      if (!prefersReduced && 'IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
        );
        const reveal = (el, delayMs) => {
          if (!el) return;
          el.classList.add('s6oh-reveal');
          el.style.transitionDelay = `${delayMs}ms`;
          revealObserver.observe(el);
        };

        reveal(root.querySelector('.s6oh__shapes-heading'), 0);
        reveal(root.querySelector('.s6oh__products-heading'), 0);
        root.querySelectorAll('.s6oh__shape-card').forEach((el, i) => reveal(el, i * 70));
        root.querySelectorAll('.s6oh__editorial-card').forEach((el, i) => reveal(el, i * 80));
        // Only the first row gets an artificial stagger - cards further down the (47-item) grid
        // already reveal in their own natural scroll order without one.
        cards.forEach((el, i) => reveal(el, Math.min(i, 5) * 60));
      }

      const heroMedia = root.querySelector('.s6oh__hero-media');

      // ---------------------------------------------------------------
      // V6: filter-reactive hero. Reads the real, pre-rendered per-shape
      // data (see the hidden [data-s6oh-shape-hero] blocks in the
      // Liquid) once, then just swaps DOM content/attributes on the
      // *existing* hero elements - it never touches `state.shape` or the
      // filtering logic in `apply()` above, only presentation.
      // ---------------------------------------------------------------
      if (heroMedia) {
        const heroImgLayers = Array.from(heroMedia.querySelectorAll('img.s6oh__hero-img'));
        const heroCardEl = heroMedia.querySelector('[data-s6oh-hero-card]');
        const heroCardBody = heroCardEl ? heroCardEl.querySelector('.s6oh__hero-card-body') : null;
        const eyebrowEl = root.querySelector('.s6oh__hero-main .s6oh__eyebrow');

        const shapeHeroData = {};
        root.querySelectorAll('[data-s6oh-shape-hero]').forEach((el) => {
          shapeHeroData[el.dataset.s6ohShapeHero] = {
            image: el.dataset.image,
            alt: el.dataset.alt,
            href: el.dataset.href,
            eyebrow: el.dataset.eyebrow,
            bodyHTML: el.innerHTML,
          };
        });

        // Only wire this up if there are 2 real <img> layers to crossfade AND at least one real
        // shape state to react to - otherwise this is silently inert (default hero stays as-is).
        if (heroImgLayers.length === 2 && Object.keys(shapeHeroData).length) {
          const activeLayer = () => heroImgLayers.find((el) => el.dataset.active === 'true') || heroImgLayers[0];
          const inactiveLayer = () => heroImgLayers.find((el) => el.dataset.active !== 'true') || heroImgLayers[1];

          const defaultHero = {
            image: activeLayer().currentSrc || activeLayer().src,
            alt: activeLayer().alt,
            href: heroCardEl ? heroCardEl.getAttribute('href') : '',
            eyebrow: eyebrowEl ? eyebrowEl.textContent : '',
            bodyHTML: heroCardBody ? heroCardBody.innerHTML : '',
          };

          // Warm the 2 real shape images in the background (not "dozens") so the first selection
          // never shows a blank/loading frame.
          Object.values(shapeHeroData).forEach((entry) => {
            if (entry.image) { const warm = new Image(); warm.src = entry.image; }
          });

          const swapHeroImage = (src, alt) => {
            if (!src) return;
            const active = activeLayer();
            const inactive = inactiveLayer();
            if (!active || !inactive || active === inactive || active.src === src) return;
            inactive.src = src;
            inactive.alt = alt || '';
            const finish = () => {
              active.dataset.active = 'false';
              inactive.dataset.active = 'true';
            };
            if (inactive.decode) inactive.decode().then(finish).catch(finish);
            else finish();
          };

          applyShapeHero = (shapeKey) => {
            const data = (shapeKey && shapeHeroData[shapeKey]) || defaultHero;
            swapHeroImage(data.image, data.alt);
            if (heroCardEl && data.href) heroCardEl.setAttribute('href', data.href);
            if (heroCardBody) heroCardBody.innerHTML = data.bodyHTML;
            if (eyebrowEl) eyebrowEl.textContent = data.eyebrow || defaultHero.eyebrow;
          };
        }
      }

      // V33 (homepage LED deep-link support): reads a small, known-safe set of URL params once on
      // initial load and feeds them into the exact same state/apply() flow every filter chip
      // already uses - by finding the matching REAL chip button and calling `.click()` on it, so
      // there is zero parallel filtering logic and zero new state object. An unsupported/unknown
      // value simply matches no button and is silently ignored (satisfies "ignore unknown values
      // safely" without an explicit allow-list check on its own - the DOM lookup already can only
      // ever match a real, existing chip). Explicit allow-lists are kept anyway for clarity/defence-
      // in-depth. Deliberately uses the FIRST matching `[data-s6oh-filter]` element in DOM order,
      // which is always the top filter-bar chip (not the further-down shape-discovery card, the
      // only other place with this same data-value) - the top-bar chips never carry
      // `data-s6oh-scroll-to-products`, so this never auto-scrolls the page; the visitor lands at
      // the top with the active chip and the instant-results panel (which sits directly below the
      // filter bar) both immediately visible, satisfying the "stay near the top" requirement with
      // no new scroll code at all.
      const urlParams = new URLSearchParams(window.location.search);
      const clickFilterChip = (group, value) => {
        const btn = root.querySelector(`[data-s6oh-filter="${group}"][data-value="${value}"]`);
        if (!btn) return;
        if (group === 'led' && extra && extra.hidden && moreBtn) moreBtn.click();
        btn.click();
      };
      const SHAPE_VALUES = ['pravokotna', 'okrogla', 'ovalna', 'pokoncna', 'nepravilna'];
      const ROOM_VALUES = ['kopalnica', 'hodnik'];
      const LED_VALUES = ['led', 'brez-led'];
      const FRAME_VALUES = ['crn', 'zlat', 'brez-okvirja', 'les'];

      const shapeParam = urlParams.get('shape');
      if (SHAPE_VALUES.includes(shapeParam)) clickFilterChip('shape', shapeParam);

      const roomParam = urlParams.get('room');
      if (ROOM_VALUES.includes(roomParam)) clickFilterChip('room', roomParam);

      // `dodatno` is the merchant-facing group LABEL shown above both the LED and frame chips in
      // the UI ("Dodatno") - the real state is still split across two separate keys underneath
      // (`led`/`frame`), so a `dodatno` param is routed to whichever one its value actually
      // belongs to. `led=`/`frame=` are also accepted directly against the canonical state keys.
      const dodatnoParam = urlParams.get('dodatno');
      if (LED_VALUES.includes(dodatnoParam)) clickFilterChip('led', dodatnoParam);
      else if (FRAME_VALUES.includes(dodatnoParam)) clickFilterChip('frame', dodatnoParam);

      const ledParam = urlParams.get('led');
      if (LED_VALUES.includes(ledParam)) clickFilterChip('led', ledParam);

      const frameParam = urlParams.get('frame');
      if (FRAME_VALUES.includes(frameParam)) clickFilterChip('frame', frameParam);

      const makeupParam = urlParams.get('makeup');
      if (makeupParam === 'true' || makeupParam === '1') clickFilterChip('makeup', 'true');

      // ---------------------------------------------------------------
      // V5: hero "living light" + cinematic parallax. Desktop-with-mouse
      // only, paused whenever the hero scrolls out of view, and it only
      // ever writes CSS custom properties - never `.style.transform`
      // directly - so it can never fight the hover rules already
      // defined in the stylesheet above.
      // ---------------------------------------------------------------
      const canParallax = !prefersReduced && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (heroMedia && canParallax) {
        const heroImage = heroMedia.querySelector('.s6oh__hero-image');
        const heroEditorial = heroMedia.querySelector('.s6oh__hero-editorial');
        const heroCard = heroMedia.querySelector('.s6oh__hero-card');

        let targetX = 0;
        let targetY = 0;
        let curX = 0;
        let curY = 0;
        let raf = null;
        const lerp = (a, b, t) => a + (b - a) * t;

        const tick = () => {
          // Slow, smoothed easing toward the pointer (or back to 0,0 on leave) - this is the
          // entire "cinematic, nothing follows the cursor directly" effect; there is no separate
          // CSS transition racing it.
          curX = lerp(curX, targetX, 0.055);
          curY = lerp(curY, targetY, 0.055);

          if (heroImage) {
            heroImage.style.setProperty('--s6oh-px-bg', `${(curX * 4).toFixed(2)}px`);
            heroImage.style.setProperty('--s6oh-py-bg', `${(curY * 4).toFixed(2)}px`);
            heroImage.style.setProperty('--s6oh-glow-x', `${(62 + curX * 9).toFixed(1)}%`);
            heroImage.style.setProperty('--s6oh-glow-y', `${(36 + curY * 9).toFixed(1)}%`);
          }
          if (heroEditorial) {
            heroEditorial.style.setProperty('--s6oh-px-fg', `${(curX * 7).toFixed(2)}px`);
            heroEditorial.style.setProperty('--s6oh-py-fg', `${(curY * 7).toFixed(2)}px`);
          }
          if (heroCard) {
            heroCard.style.setProperty('--s6oh-px-card', `${(curX * 9).toFixed(2)}px`);
            heroCard.style.setProperty('--s6oh-py-card', `${(curY * 9).toFixed(2)}px`);
          }

          raf = requestAnimationFrame(tick);
        };

        heroMedia.addEventListener('pointermove', (event) => {
          const rect = heroMedia.getBoundingClientRect();
          targetX = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - 0.5) * 2));
          targetY = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - 0.5) * 2));
        });
        heroMedia.addEventListener('pointerleave', () => {
          targetX = 0;
          targetY = 0;
        });

        // Only animate while the hero is actually on screen.
        const visibility = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !raf) raf = requestAnimationFrame(tick);
              else if (!entry.isIntersecting && raf) {
                cancelAnimationFrame(raf);
                raf = null;
              }
            });
          },
          { threshold: 0 }
        );
        visibility.observe(heroMedia);
      }

      // ---------------------------------------------------------------
      // V7: lighting preview control. Entirely independent of `state` /
      // `applyShapeHero` above - it only ever writes --s6oh-light-rgb
      // and --s6oh-light-dimmer, two CSS custom properties the V5 glow
      // layer already reads, so a shape change and a temperature change
      // can never step on each other. Presentation only: no product,
      // variant, cart or price data is read or written here.
      // ---------------------------------------------------------------
      const lightPanel = root.querySelector('[data-s6oh-light]');
      if (lightPanel) {
        const TEMP_RGB = { 3000: [255, 210, 165], 4000: [255, 238, 220], 6000: [238, 242, 250] };
        const glowLayer = heroMedia ? heroMedia.querySelector('.s6oh__hero-image') : null;
        const lightDot = lightPanel.querySelector('[data-s6oh-light-dot]');
        const dimmerInput = lightPanel.querySelector('[data-s6oh-dimmer]');
        let currentRgb = TEMP_RGB[3000];
        let colorRaf = null;

        const setRgbVar = (rgb) => {
          const value = `${Math.round(rgb[0])} ${Math.round(rgb[1])} ${Math.round(rgb[2])}`;
          if (glowLayer) glowLayer.style.setProperty('--s6oh-light-rgb', value);
          if (lightDot) lightDot.style.setProperty('--s6oh-light-rgb', value);
        };
        setRgbVar(currentRgb);

        // Gradient color-stops don't transition via plain CSS (confirmed in V5's build), so a
        // 3000K<->6000K change gets a short, self-contained rAF tween here - separate from, and
        // much shorter-lived than, the continuous parallax loop above (never running at the same
        // time as a duplicate of it: this one starts on click and stops itself ~550ms later).
        const animateTo = (targetRgb) => {
          cancelAnimationFrame(colorRaf);
          if (prefersReduced) {
            currentRgb = targetRgb;
            setRgbVar(currentRgb);
            return;
          }
          const fromRgb = currentRgb;
          const start = performance.now();
          const duration = 600;
          const ease = (t) => 1 - Math.pow(1 - t, 3); // cubic ease-out
          const step = (now) => {
            const t = Math.min(1, (now - start) / duration);
            const eased = ease(t);
            currentRgb = fromRgb.map((c, i) => c + (targetRgb[i] - c) * eased);
            setRgbVar(currentRgb);
            if (t < 1) colorRaf = requestAnimationFrame(step);
            else currentRgb = targetRgb;
          };
          colorRaf = requestAnimationFrame(step);
        };

        // Optional microinteraction (V7 §9): the light briefly reads as "switching on" rather than
        // just recoloring - a quick +6% dimmer bump that settles back, via the SAME CSS transition
        // the dimmer slider itself already uses, so no separate animation system is needed.
        const pulse = () => {
          if (prefersReduced || !glowLayer) return;
          const base = dimmerInput ? Number(dimmerInput.value) / 100 : 0.82;
          glowLayer.style.setProperty('--s6oh-light-dimmer', Math.min(1, base * 1.07).toFixed(3));
          setTimeout(() => glowLayer.style.setProperty('--s6oh-light-dimmer', base.toFixed(3)), 160);
        };

        lightPanel.querySelectorAll('[data-s6oh-temp]').forEach((btn) => {
          btn.addEventListener('click', () => {
            const kelvin = btn.dataset.s6ohTemp;
            lightPanel.querySelectorAll('[data-s6oh-temp]').forEach((b) => {
              const active = b === btn;
              b.classList.toggle('is-active', active);
              b.setAttribute('aria-pressed', active);
            });
            animateTo(TEMP_RGB[kelvin] || TEMP_RGB[3000]);
            pulse();
          });
        });

        if (dimmerInput && glowLayer) {
          glowLayer.style.setProperty('--s6oh-light-dimmer', (Number(dimmerInput.value) / 100).toFixed(3));
          dimmerInput.addEventListener('input', () => {
            glowLayer.style.setProperty('--s6oh-light-dimmer', (Number(dimmerInput.value) / 100).toFixed(3));
          });
        }
      }

      // ---------------------------------------------------------------
      // V9: room visualizer ("Vstavite ogledalo v kopalnico"). Fully
      // self-contained - its own elements, its own --s6oh-rv-* custom
      // properties, its own state. Never reads or writes state.shape,
      // applyShapeHero, --s6oh-light-*, --s6oh-px-*/--s6oh-glow-*, or
      // anything else defined above.
      // ---------------------------------------------------------------
      const roomviz = root.querySelector('[data-s6oh-roomviz]');
      const roomvizOpenBtn = root.querySelector('[data-s6oh-roomviz-open]');
      if (roomviz && roomvizOpenBtn) {
        const dialog = roomviz.querySelector('[data-s6oh-roomviz-dialog]');
        const scene = roomviz.querySelector('[data-s6oh-roomviz-scene]');
        const sceneImg = roomviz.querySelector('[data-s6oh-roomviz-scene-img]');
        const sceneBlurImg = roomviz.querySelector('[data-s6oh-roomviz-scene-blur]');
        const mirrorImg = roomviz.querySelector('[data-s6oh-roomviz-mirror-img]');
        const haloEl = roomviz.querySelector('[data-s6oh-roomviz-halo]');
        const mirror2El = roomviz.querySelector('[data-s6oh-roomviz-mirror2]');
        const glowLayer2 = roomviz.querySelector('[data-s6oh-roomviz-m-glow]');
        const resetBtn = roomviz.querySelector('[data-s6oh-roomviz-reset]');
        const roomsWrap = roomviz.querySelector('[data-s6oh-roomviz-rooms]');
        const mirrorsWrap = roomviz.querySelector('[data-s6oh-roomviz-mirrors]');
        const previewOnlyInput = roomviz.querySelector('[data-s6oh-roomviz-preview-only]');
        const scaleInput = roomviz.querySelector('[data-s6oh-roomviz-scale]');
        const scaleValueEl = roomviz.querySelector('[data-s6oh-roomviz-scale-value]');
        const productTitleEl = roomviz.querySelector('[data-s6oh-roomviz-product-title]');
        const productLinkEl = roomviz.querySelector('[data-s6oh-roomviz-product-link]');
        const unavailableEl = roomviz.querySelector('[data-s6oh-roomviz-unavailable]');
        const lightPanel = roomviz.querySelector('[data-s6oh-roomviz-light]');
        const lightDotEl = roomviz.querySelector('[data-s6oh-roomviz-light-dot]');
        const dimmerInput = roomviz.querySelector('[data-s6oh-roomviz-dimmer]');

        // V4 §6/8: this tool's OWN color-temperature values, independent of the hero's V7 light
        // panel (no shared DOM/state). V7 (roomviz): retuned to warm-ivory/neutral-white/cool-
        // neutral-white - the old values read too saturated/orange at 3000K for a believable wall
        // glow; these stay close to white with only a gentle tint, per spec ("never orange, never
        // blue"). Read by BOTH the legacy `.halo` layer and the new layered renderer's `.m-glow`.
        const RV_TEMP_RGB = { 3000: '255 226 196', 4000: '255 244 232', 6000: '242 246 250' };
        let rvTempKelvin = 3000;

        // Real bathroom config (V2: real photos, V4: re-tuned anchors), read once from the hidden
        // data blocks in the Liquid - one clean place to adjust anchoring or swap photos later
        // without touching JS. c1/c2 (room-thumb swatch gradient stops) derive from the same real
        // fallback color rather than being a separate, easy-to-forget pair of fields.
        const rooms = Array.from(roomviz.querySelectorAll('[data-s6oh-room]')).map((el) => {
          const fallback = el.dataset.fallback || '#e5e0d8';
          return {
            id: el.dataset.id,
            name: el.dataset.name,
            image: el.dataset.image,
            fallback,
            c1: fallback,
            c2: fallback,
            fit: el.dataset.sceneFit || 'cover',
            zoom: Number(el.dataset.sceneZoom) || 1,
            posX: el.dataset.scenePosX || '50',
            posY: el.dataset.scenePosY || '50',
            x: Number(el.dataset.mirrorX),
            y: Number(el.dataset.mirrorY),
            width: Number(el.dataset.mirrorWidth),
            minWidth: Number(el.dataset.minWidth),
            maxWidth: Number(el.dataset.maxWidth),
          };
        });
        // The 5 real scene photos are the ONE thing worth preloading here (unlike the 51-product
        // grid) - warmed the moment the tool opens, not on page load, so switching between all 5
        // bathrooms feels instant on the very first visit without taxing everyone else's page.
        let scenesWarmed = false;
        const warmScenes = () => {
          if (scenesWarmed) return;
          scenesWarmed = true;
          rooms.forEach((room) => { if (room.image) { const warm = new Image(); warm.src = room.image; } });
        };

        // Real transparent mirror cutouts (Set A, 12 products) PLUS each one's own real per-mirror
        // tuning, keyed by product handle. Read from the hidden [data-s6oh-cutout] blocks in the
        // Liquid above (same asset-url pattern already used for the 5 bathroom photos and the
        // guide-card image) - this script section is compiled as static JS and cannot itself use
        // Liquid template syntax, so the resolved URLs have to be produced up in the markup, not
        // written directly in this file. Products outside this set of 12 have no entry here and
        // correctly fall back to the "unavailable" message below - this map is the ONLY place
        // that decides which products can render on the wall, never a hardcoded list in the JS.
        const HALO_RADIUS = { circle: '50%', pill: '50%', 'tall-rect': '38%', rect: '30%' };
        const CUTOUT_CONFIG = Object.fromEntries(
          Array.from(roomviz.querySelectorAll('[data-s6oh-cutout]')).map((el) => [
            el.dataset.handle,
            {
              url: el.dataset.image,
              aspect: Number(el.dataset.aspect) || 1,
              halo: el.dataset.halo || 'circle',
              haloRadius: HALO_RADIUS[el.dataset.halo] || '50%',
              defaultScale: Number(el.dataset.defaultScale) || 100,
              minScale: Number(el.dataset.minScale) || 70,
              maxScale: Number(el.dataset.maxScale) || 130,
              // V7: only present on the 3 pilot products - absent everywhere else, which is what
              // keeps them on the legacy <img> cutout renderer this phase.
              layered: el.dataset.renderMode === 'layered',
              radius: el.dataset.radius || '50%',
              frameType: el.dataset.frameType || 'frameless',
              frameWidth: el.dataset.frameWidth || '1.5px',
              led: el.dataset.led === 'true',
            },
          ])
        );

        // Real mirror data, read directly from the already-rendered product grid - not a second
        // copy of the catalog. V4: raised from 20 to 60 (comfortably above the grid's real ~51
        // products) after finding only 4 of the 12 real-cutout products fell inside the old
        // 20-card window - the other 8 could never have appeared in this picker at all, which
        // directly conflicts with this phase's "verify all 12" requirement. 60 small thumbnail
        // buttons is negligible DOM/perf cost; this is a correctness fix, not scope growth.
        const MIRROR_LIMIT = 60;
        const mirrors = Array.from(root.querySelectorAll('#s6oh-products [data-s6oh-card]'))
          .slice(0, MIRROR_LIMIT)
          .map((card) => {
            const link = card.querySelector('.s6oh__card-link');
            const img = card.querySelector('.s6oh__card-img');
            const titleEl = card.querySelector('.s6oh__card-title');
            if (!link || !img || !titleEl) return null;
            const url = link.getAttribute('href');
            const handle = (url || '').split('/products/')[1]?.split('?')[0] || '';
            const cutout = CUTOUT_CONFIG[handle];
            return {
              handle,
              title: titleEl.textContent.trim(),
              url,
              img: img.currentSrc || img.src,
              hasCutout: Boolean(cutout),
              cutoutUrl: cutout ? cutout.url : null,
              aspect: cutout ? cutout.aspect : 1,
              halo: cutout ? cutout.halo : 'circle',
              haloRadius: cutout ? cutout.haloRadius : '50%',
              defaultScale: cutout ? cutout.defaultScale : 100,
              minScale: cutout ? cutout.minScale : 70,
              maxScale: cutout ? cutout.maxScale : 130,
              layered: cutout ? cutout.layered : false,
              radius: cutout ? cutout.radius : '50%',
              frameType: cutout ? cutout.frameType : 'frameless',
              frameWidth: cutout ? cutout.frameWidth : '1.5px',
              led: cutout ? cutout.led : false,
            };
          })
          .filter(Boolean);

        // Re-request the SAME already-known Shopify CDN image at a larger width for the stage
        // (still one real image per product, not a second asset) instead of stretching the small
        // grid thumbnail. Only ever used for THUMBNAILS now - never the main stage overlay.
        const upsize = (src, width) => (src ? src.replace(/width=\d+/, `width=${width}`) : src);

        // V9: per-mirror, per-room anchor/width overrides - see the markup comment above
        // [data-s6oh-room-override] for why these exist (currently populated for S611A2 only).
        const ROOM_OVERRIDES = {};
        Array.from(roomviz.querySelectorAll('[data-s6oh-room-override]')).forEach((el) => {
          const h = el.dataset.handle;
          if (!ROOM_OVERRIDES[h]) ROOM_OVERRIDES[h] = {};
          ROOM_OVERRIDES[h][el.dataset.roomId] = {
            x: Number(el.dataset.x),
            y: Number(el.dataset.y),
            width: Number(el.dataset.width),
            minWidth: Number(el.dataset.minWidth),
            maxWidth: Number(el.dataset.maxWidth),
          };
        });
        const getRoomOverride = () => {
          const mirror = mirrors[mirrorIndex];
          const room = rooms[roomIndex];
          if (!mirror || !room) return null;
          return ROOM_OVERRIDES[mirror.handle]?.[room.id] || null;
        };

        let roomIndex = 0;
        // §1: open on the first mirror that actually HAS a cutout, not just DOM-order index 0 -
        // otherwise the very first thing a visitor sees could easily be the "unavailable" message
        // even though 12 real previews exist, purely because of where that product happens to
        // fall in the grid.
        let mirrorIndex = Math.max(0, mirrors.findIndex((m) => m.hasCutout));
        let scalePercent = 100;
        let dragX = null; // null = use the current room's recommended anchor
        let dragY = null;
        let lastX = 0; // the actual clamped position last rendered by applyMirrorGeometry
        let lastY = 0;
        let lastFocused = null;

        const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

        // V3-preview-fix: the scene's actual rendered aspect ratio (16/9 both breakpoints as of
        // V4-stage-fix) - shared by size + bounds math below so they can never disagree about how
        // "tall" the current mirror renders.
        const getBoxAspect = () => {
          if (!scene) return 16 / 9;
          const rect = scene.getBoundingClientRect();
          return rect.height > 0 ? rect.width / rect.height : 16 / 9;
        };

        // V3-preview-fix: room scale first (room.width * this mirror's own real defaultScale,
        // clamped to the room's min/max), same as before - but now ALSO hard-capped so a wide
        // "rect" mirror at up to 148% scale can never dominate or overflow the frame. Both
        // dimensions scale down together on an overflow, so the real image is never stretched.
        // V4-scene-fit: caps tightened further (36/52 -> 32/44) alongside the smaller per-room
        // baselines below - the cap is now purely a safety net for tall-aspect outliers, since the
        // typical 100%-scale mirror already sits comfortably under it.
        const MAX_DEFAULT_W = 32; // % of box width
        const MAX_DEFAULT_H = 44; // % of box height
        const getMirrorSize = () => {
          const room = rooms[roomIndex];
          const mirror = mirrors[mirrorIndex];
          if (!room || !mirror) return { widthPct: 0, heightPct: 0 };
          // V9: a per-room override (currently S611A2 only) replaces the room's shared base
          // width/min/max with this mirror's own real-scale-calibrated numbers for THIS room.
          const override = getRoomOverride();
          const baseWidth = override ? override.width : room.width;
          const baseMin = override ? override.minWidth : room.minWidth;
          const baseMax = override ? override.maxWidth : room.maxWidth;
          let widthPct = clamp(baseWidth * (scalePercent / 100), baseMin, baseMax);
          let heightPct = mirror.aspect > 0 ? (widthPct * getBoxAspect()) / mirror.aspect : widthPct;
          // The generic safety cap exists to protect un-vetted mirror/room combinations from
          // overflowing - skipped ONLY when an override is active, since those exact numbers were
          // individually verified against the real photo (see the markup comment). Without this,
          // S611A2's tall aspect would get silently capped to the same ~14.4%/44% in every room
          // regardless of the calibration above, defeating the whole point of this phase.
          if (!override) {
            const over = Math.max(widthPct / MAX_DEFAULT_W, heightPct / MAX_DEFAULT_H, 1);
            if (over > 1) {
              widthPct /= over;
              heightPct /= over;
            }
          }
          return { widthPct, heightPct };
        };

        // §4: the bounds that keep at least `visibleFraction` of the mirror's CURRENT rendered
        // size on-screen. Worst case (mirror pushed to the left edge): the visible width left is
        // halfW + centerX, which must stay >= visibleFraction * (2 * halfW) - solving for centerX
        // gives the min below (and its mirror image for the max, and the same on the Y axis).
        // visibleFraction=1 is the untouched default/room-switch/mirror-switch placement - per
        // this phase's #1, it must ALWAYS load fully visible, never require a drag to see the
        // rest. 0.68 is the more permissive bound while actively dragging (matches the original
        // allowance of dragging it further toward - never fully past - the edge).
        const getBounds = (widthPct, heightPct, visibleFraction) => {
          const k = 2 * visibleFraction - 1;
          const halfW = widthPct / 2;
          const halfH = heightPct / 2;
          return {
            minX: clamp(halfW * k, 0, 50),
            maxX: clamp(100 - halfW * k, 50, 100),
            minY: clamp(halfH * k, 0, 50),
            maxY: clamp(100 - halfH * k, 50, 100),
          };
        };

        const getDragBounds = () => {
          const { widthPct, heightPct } = getMirrorSize();
          return getBounds(widthPct, heightPct, 0.68);
        };

        // The one function that actually positions/sizes the mirror (and its halo, which always
        // tracks it 1:1) - called after a room switch, a mirror switch, a scale-slider move, a
        // drag or a reset, so all of them share one real min/max-aware calculation instead of
        // several slightly different ones. V3-preview-fix: the room's recommended anchor is now
        // clamped through the same full-visibility bounds as a safe drag target, so a tall mirror
        // anchored near the top of a room can never render clipped by default.
        const applyMirrorGeometry = () => {
          const room = rooms[roomIndex];
          const mirror = mirrors[mirrorIndex];
          if (!room || !mirrorImg) return;
          const { widthPct, heightPct } = getMirrorSize();
          const bounds = getBounds(widthPct, heightPct, 1);
          // V9: the override's own x/y (this mirror's real vanity-centered anchor for THIS room)
          // stands in for the room's shared anchor when present - same dragX/dragY-null fallback
          // pattern as always, so drag/reset/room-switch all keep working unchanged.
          const override = getRoomOverride();
          const anchorX = override ? override.x : room.x;
          const anchorY = override ? override.y : room.y;
          const x = clamp(dragX == null ? anchorX : dragX, bounds.minX, bounds.maxX);
          const y = clamp(dragY == null ? anchorY : dragY, bounds.minY, bounds.maxY);
          // V3-preview-fix: the ACTUAL clamped position just rendered - not the room's raw
          // anchor - so a drag that starts from a clamped mirror begins from where it visually
          // is, never a jump to the unclamped anchor on the first pointermove.
          lastX = x;
          lastY = y;
          mirrorImg.style.setProperty('--s6oh-rv-x', `${x}%`);
          mirrorImg.style.setProperty('--s6oh-rv-y', `${y}%`);
          mirrorImg.style.setProperty('--s6oh-rv-w', `${widthPct}%`);
          if (haloEl && mirror) {
            haloEl.style.setProperty('--s6oh-rv-x', `${x}%`);
            haloEl.style.setProperty('--s6oh-rv-y', `${y}%`);
            haloEl.style.setProperty('--s6oh-rv-w', `${widthPct}%`);
            haloEl.style.setProperty('--s6oh-rv-aspect', String(mirror.aspect));
            haloEl.style.setProperty('--s6oh-rv-halo-radius', mirror.haloRadius);
          }
          // V7: the new layered renderer shares the exact same x/y/w/aspect - it's the SAME
          // mirror at the SAME position, just drawn differently. `radius`/`frameType`/
          // `frameWidth` come straight from that product's own config, never guessed here.
          if (mirror2El && mirror) {
            mirror2El.style.setProperty('--s6oh-rv-x', `${x}%`);
            mirror2El.style.setProperty('--s6oh-rv-y', `${y}%`);
            mirror2El.style.setProperty('--s6oh-rv-w', `${widthPct}%`);
            mirror2El.style.setProperty('--s6oh-rv-aspect', String(mirror.aspect));
            mirror2El.style.setProperty('--s6oh-rv-radius', mirror.radius);
            mirror2El.style.setProperty('--s6oh-rv-frame-width', mirror.frameWidth);
            mirror2El.dataset.frameType = mirror.frameType;
            if (glowLayer2) glowLayer2.hidden = !mirror.led;
          }
        };

        const renderScene = () => {
          const room = rooms[roomIndex];
          if (!room || !scene) return;
          scene.style.setProperty('--s6oh-rv-fallback', room.fallback);
          // V4.2: real per-room zoom/position - written once here rather than duplicated per
          // room in CSS, same pattern as every other per-room var already on this element.
          scene.style.setProperty('--s6oh-rv-zoom', String(room.zoom));
          scene.style.setProperty('--s6oh-rv-pos-x', `${room.posX}%`);
          scene.style.setProperty('--s6oh-rv-pos-y', `${room.posY}%`);
          // §10: switching bathroom resets to ITS recommended anchor - selected mirror and its
          // scale are left alone (only position resets, matching the given behavior exactly).
          dragX = null;
          dragY = null;
          // V9 §8: when the NEWLY selected room has a per-room override for the current mirror
          // (S611A2 only, currently), also reset the scale slider to this mirror's real
          // calibrated default for THAT room - a raw scalePercent carried over from a previous
          // room would apply against a different physical-scale base and read wrong. Every other
          // mirror/room combination keeps the existing "scale persists across rooms" behavior.
          const roomSwitchOverride = getRoomOverride();
          const roomSwitchMirror = mirrors[mirrorIndex];
          if (roomSwitchOverride && roomSwitchMirror) {
            if (scaleInput) scaleInput.value = roomSwitchMirror.defaultScale;
            renderScale(roomSwitchMirror.defaultScale);
          }
          if (sceneImg) {
            // V4.1: per-room fit, never guessed from the box ratio - see `data-scene-fit`.
            sceneImg.classList.toggle('s6oh-roomviz__scene-img--contain', room.fit === 'contain');
          }
          if (sceneImg && room.image) {
            sceneImg.hidden = false;
            if (sceneImg.src === room.image) {
              sceneImg.classList.add('is-loaded');
            } else {
              sceneImg.classList.remove('is-loaded');
              const onLoad = () => sceneImg.classList.add('is-loaded');
              sceneImg.addEventListener('load', onLoad, { once: true });
              sceneImg.src = room.image;
            }
          }
          // V4.2 §4: the blurred backdrop is the SAME photo (no second asset) - always `cover`,
          // regardless of the sharp layer's own fit, so it fills the box completely and shows
          // through wherever `contain`'s letterbox (or a `cover` room's zoom<1 pullback) leaves a
          // gap. Loaded/faded in exactly like the sharp layer above.
          if (sceneBlurImg && room.image) {
            sceneBlurImg.hidden = false;
            if (sceneBlurImg.src === room.image) {
              sceneBlurImg.classList.add('is-loaded');
            } else {
              sceneBlurImg.classList.remove('is-loaded');
              const onBlurLoad = () => sceneBlurImg.classList.add('is-loaded');
              sceneBlurImg.addEventListener('load', onBlurLoad, { once: true });
              sceneBlurImg.src = room.image;
            }
          }
          applyMirrorGeometry();
          roomsWrap?.querySelectorAll('[data-s6oh-room-index]').forEach((btn, i) => btn.classList.toggle('is-active', i === roomIndex));
        };

        const renderScale = (value) => {
          scalePercent = value;
          applyMirrorGeometry();
          if (scaleValueEl) scaleValueEl.textContent = `${value}%`;
        };

        // V3: the ONLY place that decides what appears in the stage. A mirror with a real cutout
        // renders as the overlay image (transparent PNG); one without renders NO image at all -
        // the "unavailable" message instead. Never a full product photo here, regardless.
        // V4 §2: selecting a mirror also resets the scale control to THIS mirror's own real
        // default/min/max (a round mirror and a 165cm pokončna one have no business sharing one
        // slider range) and shows/hides its halo - position keeps whatever the current room's
        // recommended anchor already is (matching §10's "only position resets on room change").
        const renderMirror = () => {
          const mirror = mirrors[mirrorIndex];
          if (!mirror) return;
          // Product info (title/price/CTA) is real data either way, so it stays populated
          // whether or not this specific mirror can be previewed on the wall yet.
          if (productTitleEl) productTitleEl.textContent = mirror.title;
          if (productLinkEl) productLinkEl.setAttribute('href', mirror.url);

          if (mirror.hasCutout && mirror.layered && mirror2El) {
            // V7: clean layered renderer - the cutout PNG's URL is never assigned to an <img>
            // here, so its RGB literally cannot appear anywhere on screen for this product.
            mirror2El.hidden = false;
            if (mirrorImg) { mirrorImg.hidden = true; mirrorImg.removeAttribute('src'); }
            if (haloEl) haloEl.hidden = true;
            if (unavailableEl) unavailableEl.hidden = true;
            if (scaleInput) {
              scaleInput.min = mirror.minScale;
              scaleInput.max = mirror.maxScale;
              scaleInput.value = mirror.defaultScale;
            }
            renderScale(mirror.defaultScale);
          } else if (mirror.hasCutout && mirrorImg) {
            if (mirror2El) mirror2El.hidden = true;
            mirrorImg.src = mirror.cutoutUrl;
            mirrorImg.alt = mirror.title;
            mirrorImg.hidden = false;
            if (unavailableEl) unavailableEl.hidden = true;
            if (haloEl) haloEl.hidden = false;
            if (scaleInput) {
              scaleInput.min = mirror.minScale;
              scaleInput.max = mirror.maxScale;
              scaleInput.value = mirror.defaultScale;
            }
            renderScale(mirror.defaultScale);
          } else {
            if (mirrorImg) { mirrorImg.hidden = true; mirrorImg.removeAttribute('src'); }
            if (mirror2El) mirror2El.hidden = true;
            if (unavailableEl) unavailableEl.hidden = false;
            if (haloEl) haloEl.hidden = true;
          }
          mirrorsWrap?.querySelectorAll('[data-s6oh-mirror-index]').forEach((btn, i) => btn.classList.toggle('is-active', i === mirrorIndex));
        };

        // Build the two thumbnail strips once - static lists, no need to re-render per selection.
        if (roomsWrap) {
          rooms.forEach((room, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 's6oh-roomviz__room-thumb';
            btn.dataset.s6ohRoomIndex = i;
            btn.innerHTML = `<span class="s6oh-roomviz__room-swatch" style="--room-c1:${room.c1};--room-c2:${room.c2}"></span><span class="s6oh-roomviz__room-name">${room.name}</span>`;
            btn.addEventListener('click', () => {
              roomIndex = i;
              renderScene();
            });
            roomsWrap.appendChild(btn);
          });
        }
        if (mirrorsWrap) {
          mirrors.forEach((mirror, i) => {
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 's6oh-roomviz__mirror-thumb';
            btn.dataset.s6ohMirrorIndex = i;
            btn.dataset.s6ohHasCutout = String(mirror.hasCutout);
            const img = document.createElement('img');
            img.className = mirror.hasCutout ? 's6oh-roomviz__mirror-thumb-img' : 's6oh-roomviz__mirror-thumb-img no-cutout';
            img.src = upsize(mirror.img, 150);
            img.loading = 'lazy';
            img.alt = '';
            img.width = 84;
            img.height = 84;
            const name = document.createElement('span');
            name.className = 's6oh-roomviz__mirror-name';
            name.textContent = mirror.title;
            btn.append(img, name);
            // Thumbnails stay real product photos either way (explicitly allowed) - this badge is
            // the only visual difference, so the picker honestly shows what will and won't render
            // in the stage without hiding any mirror from the full catalog by default.
            if (!mirror.hasCutout) {
              const badge = document.createElement('span');
              badge.className = 's6oh-roomviz__no-cutout-badge';
              badge.textContent = 'i';
              badge.setAttribute('aria-hidden', 'true');
              btn.appendChild(badge);
              btn.title = I18N.roomvizUnavailable || '';
            }
            btn.addEventListener('click', () => {
              mirrorIndex = i;
              renderMirror();
            });
            mirrorsWrap.appendChild(btn);
          });
        }

        // §9: OFF by default (checkbox unchecked) - the full catalog stays in the picker either
        // way, this only hides the ones that can't render on the wall yet so a visitor can jump
        // straight to the 12 that do.
        if (previewOnlyInput && mirrorsWrap) {
          previewOnlyInput.addEventListener('change', () => {
            mirrorsWrap.querySelectorAll('[data-s6oh-mirror-index]').forEach((btn) => {
              btn.hidden = previewOnlyInput.checked && btn.dataset.s6ohHasCutout !== 'true';
            });
          });
        }

        // §2/§5: the slider's min/max/value are set per-mirror by renderMirror() itself (each
        // mirror carries its own real range), so this only needs to wire up user input - never a
        // fixed 80-120 range shared by every shape.
        if (scaleInput) {
          scaleInput.addEventListener('input', () => renderScale(Number(scaleInput.value)));
        }

        // V2 §6: drag to reposition, mouse and touch through the SAME Pointer Events (one
        // implementation, not two) - constrained per §4 to keep at least ~68% of the mirror
        // visible, using its OWN real current size (getDragBounds), not a fixed box for every
        // mirror regardless of how large or small it currently renders.
        // V7: wired onto BOTH the legacy <img> and the new layered `.mirror2` - only one is ever
        // visible/interactable at a time (renderMirror hides the other), sharing the same drag
        // state, so dragging works identically regardless of which renderer a product uses.
        let dragging = false;
        let dragStartClientX = 0;
        let dragStartClientY = 0;
        let dragStartX = 0;
        let dragStartY = 0;
        const wireDrag = (el, dragClassTargets) => {
          if (!el || !scene) return;
          el.addEventListener('pointerdown', (event) => {
            if (event.button !== undefined && event.button !== 0) return;
            const room = rooms[roomIndex];
            if (!room) return;
            dragging = true;
            dragClassTargets.forEach((t) => t?.classList.add('is-dragging'));
            el.setPointerCapture(event.pointerId);
            dragStartClientX = event.clientX;
            dragStartClientY = event.clientY;
            dragStartX = lastX;
            dragStartY = lastY;
            event.preventDefault();
          });
          el.addEventListener('pointermove', (event) => {
            if (!dragging) return;
            const rect = scene.getBoundingClientRect();
            const dxPercent = ((event.clientX - dragStartClientX) / rect.width) * 100;
            const dyPercent = ((event.clientY - dragStartClientY) / rect.height) * 100;
            const bounds = getDragBounds();
            dragX = clamp(dragStartX + dxPercent, bounds.minX, bounds.maxX);
            dragY = clamp(dragStartY + dyPercent, bounds.minY, bounds.maxY);
            applyMirrorGeometry();
          });
          const endDrag = (event) => {
            if (!dragging) return;
            dragging = false;
            dragClassTargets.forEach((t) => t?.classList.remove('is-dragging'));
            try { el.releasePointerCapture(event.pointerId); } catch (err) { /* already released */ }
          };
          el.addEventListener('pointerup', endDrag);
          el.addEventListener('pointercancel', endDrag);
        };
        wireDrag(mirrorImg, [mirrorImg, haloEl]);
        wireDrag(mirror2El, [mirror2El]);

        // V4 §6/8: LED halo color-temperature + intensity. Writes `--s6oh-rv-*` vars on `.scene`
        // (the shared ancestor of both renderers) so they inherit down via normal CSS
        // inheritance into whichever glow layer is actually active - the legacy `.halo` or the
        // new layered renderer's `.m-glow` - without this function needing to know which one is
        // showing. Never touches the mirror <img>'s src/opacity, the scene photo, or any
        // `--s6oh-light-*` var the hero's independent V7 panel owns. V7: dimmer ceiling lowered
        // (0.6 -> 0.45) - the new glow is meant to read as "hidden behind the glass", softer than
        // before.
        const setRvTemp = (kelvin) => {
          rvTempKelvin = kelvin;
          const rgb = RV_TEMP_RGB[kelvin] || RV_TEMP_RGB[3000];
          if (scene) scene.style.setProperty('--s6oh-rv-light-rgb', rgb);
          if (lightDotEl) lightDotEl.style.setProperty('--s6oh-rv-light-rgb', rgb);
          lightPanel?.querySelectorAll('[data-s6oh-roomviz-temp]').forEach((btn) => {
            const active = Number(btn.dataset.s6ohRoomvizTemp) === kelvin;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-pressed', String(active));
          });
        };
        const setRvDimmer = (value) => {
          const alpha = (clamp(value, 0, 100) / 100) * 0.45;
          if (scene) scene.style.setProperty('--s6oh-rv-light-dimmer', alpha.toFixed(3));
        };
        if (lightPanel) {
          setRvTemp(3000);
          setRvDimmer(dimmerInput ? Number(dimmerInput.value) : 65);
          lightPanel.querySelectorAll('[data-s6oh-roomviz-temp]').forEach((btn) => {
            btn.addEventListener('click', () => setRvTemp(Number(btn.dataset.s6ohRoomvizTemp)));
          });
          dimmerInput?.addEventListener('input', () => setRvDimmer(Number(dimmerInput.value)));
        }

        // §10: "Ponastavi položaj" - restores the current room's recommended anchor, the current
        // mirror's recommended scale, and the lighting defaults, without reloading the modal.
        if (resetBtn) {
          resetBtn.addEventListener('click', () => {
            dragX = null;
            dragY = null;
            const mirror = mirrors[mirrorIndex];
            if (mirror) {
              if (scaleInput) scaleInput.value = mirror.defaultScale;
              renderScale(mirror.defaultScale);
            } else {
              applyMirrorGeometry();
            }
            setRvTemp(3000);
            if (dimmerInput) {
              dimmerInput.value = 65;
              setRvDimmer(65);
            }
          });
        }

        // Defaults are ready as soon as the section loads, so the very first open never shows an
        // empty stage.
        if (rooms.length) renderScene();
        if (mirrors.length) renderMirror();

        const FOCUSABLE = 'button, a[href], input, [tabindex]:not([tabindex="-1"])';
        const trapFocus = (event) => {
          if (event.key !== 'Tab') return;
          const focusable = Array.from(dialog.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        };

        const onKeydown = (event) => {
          if (event.key === 'Escape') closeRoomviz();
          else trapFocus(event);
        };

        function openRoomviz() {
          lastFocused = document.activeElement;
          warmScenes();
          roomviz.hidden = false;
          document.body.style.overflow = 'hidden';
          const show = () => {
            roomviz.classList.add('is-open');
            (roomviz.querySelector('[data-s6oh-roomviz-close]:not(.s6oh-roomviz__backdrop)') || dialog).focus();
          };
          if (prefersReduced) show();
          else requestAnimationFrame(() => requestAnimationFrame(show));
          document.addEventListener('keydown', onKeydown);
        }

        function closeRoomviz() {
          roomviz.classList.remove('is-open');
          document.removeEventListener('keydown', onKeydown);
          document.body.style.overflow = '';
          const finish = () => { roomviz.hidden = true; };
          if (prefersReduced) finish();
          else setTimeout(finish, 320);
          (lastFocused || roomvizOpenBtn).focus();
        }

        roomvizOpenBtn.addEventListener('click', openRoomviz);
        roomviz.querySelectorAll('[data-s6oh-roomviz-close]').forEach((el) => el.addEventListener('click', closeRoomviz));
        dialog.setAttribute('tabindex', '-1');
      }
    };

    const scan = (root) => root.querySelectorAll('.s6oh').forEach(init);
    document.addEventListener('shopify:section:load', (event) => scan(event.target));
    window.__s6ohHub = { scan };
    scan(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s6-product-explorer"] && !Shopify.designMode) return;
  try {
    
  /*
    S6 Product Explorer 3x3 (V7).
    Rows are PINNED - row 0 is always the top group, row 1 the center group, row 2 the bottom
    group. Each row owns two independent pointers: X[ri] (which column of its active layer is
    centered) and Y[ri] (which layer - 0 = collection A, 1 = collection B - is active). A row
    with only one non-empty layer simply has no vertical move. moveAllRowsY(dy) calls moveRowY on
    every row so the shared up/down control moves the whole stack together in one gesture; moveRowX
    stays per-row (left/right arrows, drag, keyboard on the center row).

    applyRow(ri, dx, dy) is the only function that ever touches the DOM or the shared `visible`
    map, and it only ever writes cells whose row is `ri`: it computes that row's new 3-cell
    window, slides tiles that are staying, and fades tiles in/out one step further in the
    direction of travel (dx: left/right, within the row's own strip; dy: up/down, from just
    above/below that row's own strip). Because every mutation is scoped to one row, a move on
    row A can never re-read or rewrite row B's state or DOM.
  */
  (() => {
    if (window.__s6xExplorer) return;

    const mod = (n, m) => ((n % m) + m) % m;

    const setup = (root) => {
      if (root.dataset.s6xReady) return;
      root.dataset.s6xReady = 'true';

      const frame = root.querySelector('.s6x__frame');
      const stage = root.querySelector('[data-s6x-stage]');
      const ring = root.querySelector('[data-s6x-ring]');
      const status = root.querySelector('[data-s6x-status]');
      const focusPanel = root.querySelector('[data-s6x-focus]');
      const labels = (root.dataset.s6xLabels || '').split('|');
      const gap = parseFloat(root.dataset.s6xGap) || 14;
      const k = parseFloat(root.dataset.s6xCenter) || 1.3;
      const duration = parseInt(root.dataset.s6xDuration, 10) || 650;
      const hoverMode = root.dataset.s6xHover || 'spin';
      const autoplaySeconds = parseFloat(root.dataset.s6xAutoplay) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Build, per data-row, its two layers (collection A / B) from the DOM. layers[ri][li] is an
         array of tiles in column order; a layer with zero tiles is dropped entirely. */
      const byRow = [];
      stage.querySelectorAll('[data-s6x-tile]').forEach((tile) => {
        const ri = Number(tile.dataset.row);
        const li = Number(tile.dataset.layer) || 0;
        byRow[ri] = byRow[ri] || [[], []];
        byRow[ri][li].push(tile);
      });
      const rowLayers = [];
      const rowLabels = [];
      byRow.forEach((layers, ri) => {
        const usable = layers.filter((l) => l.length);
        if (!usable.length) return;
        rowLayers.push(usable);
        rowLabels.push(labels[ri] || '');
      });
      const R = Math.min(3, rowLayers.length);
      if (!R) return;

      const X = rowLayers.map(() => 1);
      const Y = rowLayers.map(() => 0);
      let metrics = null;
      const visible = new Map(); // tile -> {ci, cj}
      const rowCells = [new Map(), new Map(), new Map()]; // per-row: cj -> tile, for this row's current 3 cells

      const measure = () => {
        const S = stage.clientWidth;
        const unit = (S - 2 * gap) / (2 + k);
        metrics = { unit, sizes: [unit, unit * k, unit], pos: [0, unit + gap, unit + gap + unit * k + gap] };
      };

      /* Rect for a cell; indexes -1 and 3 are "just outside" the stage (or, for a single row's
         vertical move, just outside that row's own strip - see place()/applyRow() below). */
      const cellRect = (ci, cj) => {
        const m = metrics;
        const pos = (n) => (n < 0 ? -(m.unit + gap) : n > 2 ? m.pos[2] + m.sizes[2] + gap : m.pos[n]);
        const size = (n) => (n < 0 || n > 2 ? m.unit : m.sizes[n]);
        return { x: pos(cj), y: pos(ci), w: size(cj), h: size(ci) };
      };

      const place = (tile, rect, opacity) => {
        tile.style.width = `${rect.w}px`;
        tile.style.height = `${rect.h}px`;
        tile.style.transform = `translate(${rect.x}px, ${rect.y}px)`;
        tile.style.opacity = opacity;
      };

      const colAt = (len, pointer, cj) => {
        const d = cj - 1;
        if (len >= 3) return mod(pointer + d, len);
        return cj < len ? cj : -1;
      };

      /* The single, globally-emphasized "hero" tile (bigger, glowing, ring accent) stays exactly
         where it always was: row 1's own center column. Separately, `rowCenterTile(ri)` reads
         ANY row's own center-column tile (column 1 of that row) - this is what the 180deg spin
         trigger below is keyed off now, per row, instead of being hardcoded to row 1. */
      const rowCenterTile = (ri) => (rowCells[ri] ? rowCells[ri].get(1) : null) || null;

      const updateStatus = (ri) => {
        const layer = rowLayers[ri][Y[ri]];
        const tile = rowCells[ri].get(1);
        if (ri === 1 && status && tile) {
          const idx = layer.indexOf(tile);
          const label = rowLabels[ri];
          status.textContent = `${label ? `${label} · ` : ''}${idx + 1} / ${layer.length}`;
        }
        if (ri === 1 && focusPanel && tile) {
          focusPanel.href = tile.href;
          const info = tile.querySelector('.s6x__info');
          focusPanel.innerHTML = info ? info.outerHTML : '';
        }
      };

      const spinRing = () => {
        if (!ring || reduceMotion) return;
        ring.classList.remove('is-spin');
        void ring.offsetWidth;
        ring.classList.add('is-spin');
      };

      const layoutChrome = () => {
        if (ring) {
          const rect = cellRect(1, 1);
          const pad = 6;
          ring.style.transform = `translate(${rect.x - pad}px, ${rect.y - pad}px)`;
          ring.style.width = `${rect.w + pad * 2}px`;
          ring.style.height = `${rect.h + pad * 2}px`;
        }
        frame.querySelectorAll('[data-s6x-row-nav]').forEach((button) => {
          const [ciStr, axis] = button.dataset.s6xRowNav.split(',');
          const ci = Number(ciStr);
          if (ci >= R) {
            button.hidden = true;
            return;
          }
          button.classList.toggle('is-center-row', ci === 1);
          const isVertical = axis === 'up' || axis === 'down';
          if (isVertical) {
            // Top/bottom-center position is fixed by CSS (grid-centered), not row-dependent.
            // Moves the whole stack, so only disable if literally no row has a second layer.
            button.disabled = rowLayers.every((layers) => layers.length < 2);
            return;
          }
          const rect = cellRect(ci, 1);
          button.style.top = `${rect.y + rect.h / 2}px`;
        });
      };

      /* Motion trail: 1-2 faint ghost glows offset opposite the direction of travel (so they
         read as trailing "behind" the tile), gone entirely when nothing is moving or under
         reduced motion. Purely a box-shadow fade - no extra DOM, no long-running animation. */
      const applyTrail = (tile, dx, dy, isCenterTile) => {
        if (reduceMotion || (!dx && !dy)) return;
        const bx = dx > 0 ? -1 : dx < 0 ? 1 : 0;
        const by = dy > 0 ? -1 : dy < 0 ? 1 : 0;
        tile.style.setProperty('--s6x-trail-1-x', `${bx * 10}px`);
        tile.style.setProperty('--s6x-trail-1-y', `${by * 10}px`);
        tile.style.setProperty('--s6x-trail-1-o', isCenterTile ? 0.2 : 0.15);
        tile.style.setProperty('--s6x-trail-2-x', `${bx * 20}px`);
        tile.style.setProperty('--s6x-trail-2-y', `${by * 20}px`);
        tile.style.setProperty('--s6x-trail-2-o', isCenterTile ? 0.12 : 0.08);
        clearTimeout(tile.__s6xTrailTimer);
        tile.__s6xTrailTimer = setTimeout(() => {
          tile.style.setProperty('--s6x-trail-1-o', 0);
          tile.style.setProperty('--s6x-trail-2-o', 0);
        }, duration);
      };

      /* Render row `ri` only: its new 3-cell window (from layer Y[ri], centered on X[ri]),
         entering/exiting via (dx, dy) - the direction this particular move travelled in.
         Never reads or writes any other row. */
      const applyRow = (ri, dx, dy) => {
        const layer = rowLayers[ri][Y[ri]];
        const len = layer.length;
        const next = new Map(); // cj -> tile
        for (let cj = 0; cj < 3; cj++) {
          const idx = colAt(len, X[ri], cj);
          if (idx < 0) continue;
          next.set(cj, layer[idx]);
        }

        const prev = rowCells[ri];
        const beforeRowCenter = rowCenterTile(ri);

        prev.forEach((tile, cj) => {
          if ([...next.values()].includes(tile)) return;
          applyTrail(tile, dx, dy, tile.classList.contains('is-center'));
          place(tile, cellRect(ri - dy, cj - dx), 0);
          tile.classList.remove('is-center');
          tile.tabIndex = -1;
          visible.delete(tile);
          setTimeout(() => {
            if (tile.style.opacity === '0') tile.dataset.state = 'hidden';
          }, duration);
        });

        const nextByTile = new Map();
        next.forEach((tile, cj) => {
          const wasCj = [...prev.entries()].find(([, t]) => t === tile)?.[0];
          const slid = wasCj !== undefined && wasCj - dx === cj;
          const isCenter = ri === 1 && cj === 1;
          applyTrail(tile, dx, dy, isCenter);
          if (!slid) {
            tile.classList.add('is-instant');
            place(tile, cellRect(ri + dy, cj + dx), 0);
            tile.dataset.state = 'visible';
            void tile.offsetWidth;
            tile.classList.remove('is-instant');
          }
          tile.dataset.state = 'visible';
          const img = tile.querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
          place(tile, cellRect(ri, cj), isCenter ? 1 : 0.94);
          tile.classList.toggle('is-center', isCenter);
          // Every currently-visible tile is a real product link and must stay keyboard-reachable,
          // not just the center tile. Tiles that leave visibility are set back to -1 above.
          tile.tabIndex = 0;
          visible.set(tile, { ci: ri, cj });
          nextByTile.set(cj, tile);
        });

        rowCells[ri] = nextByTile;
        updateStatus(ri);
        // Center-change spin: fires whenever THIS row's own center-column tile changed, for every
        // row - not just row 1. The ring accent (a single fixed decorative element positioned
        // around row 1's cell only) still only plays for row 1, since there's only one of it.
        const afterRowCenter = rowCenterTile(ri);
        if (beforeRowCenter !== afterRowCenter) {
          resetTileSpin(beforeRowCenter);
          if (ri === 1) spinRing();
          spinCenterImage(afterRowCenter);
        }
      };

      /* A tile that just stopped being the center settles back to its normal, unrotated state -
         this is that tile quietly resetting, not the center tile "flipping back" on itself. */
      const resetTileSpin = (tile) => {
        if (!tile) return;
        tile.querySelector('.s6x__img')?.classList.remove('is-spinning');
        tile.querySelector('.s6x__media')?.classList.remove('is-pulsing');
      };

      /* Center-change only: one 180° image flip plus a short scale pulse on the media area, that
         HOLDS at 180° (see the CSS `forwards` fill-mode) rather than flipping back. Force-restarts
         (remove -> reflow -> re-add) so it always plays a fresh 0deg -> 180deg turn, even if this
         exact tile happened to still be mid-animation or already held at 180deg from earlier. */
      const spinCenterImage = (tile) => {
        if (hoverMode !== 'spin' || reduceMotion || !tile) return;
        const media = tile.querySelector('.s6x__media');
        const img = tile.querySelector('.s6x__img');
        if (img) {
          img.classList.remove('is-spinning');
          void img.offsetWidth;
          img.classList.add('is-spinning');
        }
        if (media) {
          media.classList.remove('is-pulsing');
          void media.offsetWidth;
          media.classList.add('is-pulsing');
        }
      };

      const moveRowX = (ri, dx) => {
        if (ri < 0 || ri >= R) return;
        const layer = rowLayers[ri][Y[ri]];
        if (layer.length < 2) return;
        X[ri] += dx;
        applyRow(ri, dx, 0);
      };

      const moveRowY = (ri, dy) => {
        if (ri < 0 || ri >= R) return;
        if (rowLayers[ri].length < 2) return;
        Y[ri] = mod(Y[ri] + dy, rowLayers[ri].length);
        X[ri] = 1;
        applyRow(ri, 0, dy);
      };

      /* Vertical navigation moves the WHOLE stack together: every row steps its own layer (A/B)
         at once. A row with only one usable layer is simply a no-op for itself (moveRowY's own
         guard), the others still move. */
      const moveAllRowsY = (dy) => {
        for (let ri = 0; ri < R; ri++) moveRowY(ri, dy);
      };

      /* Initial layout: every row fades its 3 tiles in at their own cell. */
      measure();
      layoutChrome();
      for (let ri = 0; ri < R; ri++) applyRow(ri, 0, 0);

      root.querySelectorAll('[data-s6x-row-nav]').forEach((button) => {
        const [ci, axis] = button.dataset.s6xRowNav.split(',');
        button.addEventListener('click', () => {
          if (axis === 'left') moveRowX(Number(ci), -1);
          else if (axis === 'right') moveRowX(Number(ci), 1);
          else if (axis === 'up') moveAllRowsY(-1);
          else if (axis === 'down') moveAllRowsY(1);
        });
      });

      /* Keyboard: left/right act on the center row (matching the arrows available there); up/down
         move the whole stack, matching the shared up/down control. */
      stage.addEventListener('keydown', (event) => {
        const map = {
          ArrowLeft: () => moveRowX(1, -1),
          ArrowRight: () => moveRowX(1, 1),
          ArrowUp: () => moveAllRowsY(-1),
          ArrowDown: () => moveAllRowsY(1),
        };
        const action = map[event.key];
        if (!action) return;
        event.preventDefault();
        action();
      });

      let dragged = false;
      stage.addEventListener(
        'click',
        (event) => {
          if (!dragged) return;
          if (event.target.closest('[data-s6x-tile]')) event.preventDefault();
          dragged = false;
        },
        true
      );

      /* Swipe / drag: horizontal moves only the row it started on, by dominant direction.
         Vertical moves the whole stack together, matching the shared up/down control. Desktop
         only for the vertical case: vertical touch gestures are left to the page so the section
         never traps scrolling; horizontal works for touch and mouse alike. */
      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let startRow = 1;
      const cellRowAt = (clientY) => {
        const y = clientY - stage.getBoundingClientRect().top;
        for (let ci = 0; ci < R; ci++) {
          const rect = cellRect(ci, 1);
          if (y <= rect.y + rect.h + gap / 2) return ci;
        }
        return R - 1;
      };
      stage.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startRow = cellRowAt(event.clientY);
        dragged = false;
      });
      stage.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        if (Math.hypot(event.clientX - startX, event.clientY - startY) > 8) dragged = true;
      });
      stage.addEventListener('pointerup', (event) => {
        if (event.pointerId !== pointerId) return;
        pointerId = null;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.abs(dx) < 40 && Math.abs(dy) < 40) return;
        if (Math.abs(dx) >= Math.abs(dy)) moveRowX(startRow, dx < 0 ? 1 : -1);
        else if (event.pointerType === 'mouse') moveAllRowsY(dy < 0 ? -1 : 1);
      });
      stage.addEventListener('pointercancel', () => {
        pointerId = null;
      });

      /* Optional autoplay (off by default): steps the center row's own X, pauses while
         hovered/focused. */
      if (autoplaySeconds > 0 && !reduceMotion) {
        setInterval(() => {
          if (document.hidden || root.matches(':hover') || root.contains(document.activeElement)) return;
          moveRowX(1, 1);
        }, autoplaySeconds * 1000);
      }

      let raf = 0;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          measure();
          layoutChrome();
          stage.classList.add('is-instant');
          visible.forEach((cell, tile) => place(tile, cellRect(cell.ci, cell.cj), cell.ci === 1 && cell.cj === 1 ? 1 : 0.94));
          void stage.offsetWidth;
          stage.classList.remove('is-instant');
        });
      });
    };

    const scan = (root) => root.querySelectorAll('[data-s6x]').forEach(setup);

    document.addEventListener('shopify:section:load', (event) => scan(event.target));

    window.__s6xExplorer = { scan };
    scan(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s6-rect-mirrors"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Filter engine for the rectangular mirrors page. It follows the SAME contract as the hub engine in
    // sections/s6-ogledala-hub.liquid (same markup from snippets/s6oh-filterbar.liquid, same card data
    // attributes from snippets/s6oh-product-card.liquid, same matching rules, same i18n JSON), because
    // section JavaScript is only shipped on pages that render that section, so the hub script cannot run
    // here. If the hub engine is ever present on the same page, this one stays out of the way.
    const initRect = (root) => {
      if (root.dataset.s6rReady || window.__s6ohHub) return;
      root.dataset.s6rReady = 'true';
      const grid = root.querySelector('[data-s6oh-grid]');
      if (!grid) return;
      const cards = Array.from(grid.querySelectorAll('[data-s6oh-card]'));
      const empty = root.querySelector('[data-s6oh-empty]');
      const state = { room: null, makeup: null, size: null, frame: null, light: null };
      let I18N = {};
      try { I18N = JSON.parse(root.dataset.s6ohI18n || '{}'); } catch (e) { I18N = {}; }

      const sizeInRange = (value, range) => {
        if (!value) return false;
        const [min, max] = range.split('-').map(Number);
        return value >= min && value <= max;
      };
      const cardMatches = (d, s) => {
        if (s.room && !(d.room || '').split(' ').includes(s.room)) return false;
        if (s.makeup && d.makeup !== 'true') return false;
        if (s.size && !sizeInRange(Number(d.size), s.size)) return false;
        if (s.frame && d.frame !== s.frame) return false;
        if (s.light && !(d.light || '').split(' ').includes(s.light)) return false;
        return true;
      };

      const instant = root.querySelector('[data-s6oh-instant]');
      const summaryEl = root.querySelector('[data-s6oh-instant-summary]');
      const countEl = root.querySelector('[data-s6oh-instant-count]');
      const previewLabel = root.querySelector('[data-s6oh-instant-preview-label]');
      const track = root.querySelector('[data-s6oh-instant-track]');
      const emptyBox = root.querySelector('[data-s6oh-instant-empty]');
      const cta = root.querySelector('[data-s6oh-instant-cta]');
      const ctaLabel = cta ? cta.querySelector('[data-s6oh-instant-cta-label]') : null;
      const PREVIEW_MAX = 6;

      const chipLabel = (group, value) => {
        const chip = root.querySelector(`[data-s6oh-filter="${group}"][data-value="${value}"]`);
        return chip ? chip.textContent.replace(/\s+/g, ' ').trim() : value;
      };
      const buildInstantCard = (card) => {
        const link = card.querySelector('.s6oh__card-link');
        const img = card.querySelector('.s6oh__card-img--primary');
        const title = card.querySelector('.s6oh__card-title');
        const spec = card.querySelector('.s6oh__card-spec');
        const price = card.querySelector('.s6oh__card-price');
        const badge = card.querySelector('.s6oh__badge');
        if (!link || !img || !title || !price) return null;
        const a = document.createElement('a');
        a.className = 's6oh__instant-card';
        a.href = link.getAttribute('href');
        const media = document.createElement('span');
        media.className = 's6oh__instant-card-media';
        media.appendChild(img.cloneNode(true));
        if (badge) media.appendChild(badge.cloneNode(true));
        a.appendChild(media);
        const titleEl = document.createElement('span');
        titleEl.className = 's6oh__instant-card-title';
        titleEl.textContent = title.textContent.trim();
        a.appendChild(titleEl);
        if (spec) {
          const specEl = document.createElement('span');
          specEl.className = 's6oh__instant-card-spec';
          specEl.textContent = spec.textContent.trim();
          a.appendChild(specEl);
        }
        const priceEl = document.createElement('span');
        priceEl.className = 's6oh__instant-card-price';
        priceEl.innerHTML = price.innerHTML;
        a.appendChild(priceEl);
        return a;
      };

      const syncBlocks = () => {
        root.querySelectorAll('[data-s6r-block]').forEach((block) => {
          const any = Boolean(block.querySelector('[data-s6oh-card]:not([hidden])'));
          block.hidden = !any;
        });
      };
      const updateInstant = (visibleCards, count) => {
        if (!instant) return;
        const active = Object.keys(state).some((k) => state[k]);
        instant.hidden = !active;
        if (!active) return;
        if (summaryEl) {
          const parts = [];
          if (state.size) {
            const [min, max] = state.size.split('-').map(Number);
            parts.push((I18N.size && I18N.size[state.size]) || `${min}–${max} cm`);
          }
          if (state.room) parts.push((I18N.room && I18N.room[state.room]) || chipLabel('room', state.room));
          if (state.frame) parts.push((I18N.frame && I18N.frame[state.frame]) || chipLabel('frame', state.frame));
          if (state.light) parts.push(chipLabel('light', state.light));
          summaryEl.textContent = parts.join(' • ');
        }
        if (countEl) {
          if (count === 1) countEl.textContent = I18N.countOne || '';
          else if (count === 2) countEl.textContent = I18N.countTwo || '';
          else if (count > 0) countEl.textContent = (I18N.countOther || '').replace('__N__', count);
          else countEl.textContent = '';
        }
        if (previewLabel) {
          const truncated = count > PREVIEW_MAX;
          previewLabel.textContent = truncated ? (I18N.showingFirst || '').replace('__TOTAL__', count) : '';
          previewLabel.hidden = !truncated;
        }
        if (ctaLabel) ctaLabel.textContent = count > 0 ? (I18N.showCount || '').replace('__N__', count) : (I18N.showDefault || '');
        if (emptyBox) emptyBox.hidden = count > 0;
        if (cta) cta.hidden = count === 0;
        if (track) {
          track.textContent = '';
          visibleCards.slice(0, PREVIEW_MAX).forEach((card) => {
            const el = buildInstantCard(card);
            if (el) track.appendChild(el);
          });
        }
      };
      const apply = () => {
        let count = 0;
        const visibleCards = [];
        cards.forEach((card) => {
          const ok = cardMatches(card.dataset, state);
          card.hidden = !ok;
          if (ok && !card.hasAttribute('data-dup')) {
            count += 1;
            visibleCards.push(card);
          }
        });
        syncBlocks();
        if (empty) empty.hidden = count > 0;
        updateInstant(visibleCards, count);
      };

      root.querySelectorAll('[data-s6oh-filter]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const group = btn.dataset.s6ohFilter;
          if (!(group in state)) return;
          const next = state[group] === btn.dataset.value ? null : btn.dataset.value;
          state[group] = next;
          root.querySelectorAll(`[data-s6oh-filter="${group}"]`).forEach((b) => b.classList.toggle('is-active', b.dataset.value === next));
          apply();
        });
      });
      const resetAll = () => {
        Object.keys(state).forEach((k) => { state[k] = null; });
        root.querySelectorAll('.s6oh__chip').forEach((b) => b.classList.remove('is-active'));
        apply();
      };
      const resetBtn = root.querySelector('[data-s6oh-reset]');
      if (resetBtn) resetBtn.addEventListener('click', resetAll);
      const clearBtn = root.querySelector('[data-s6oh-instant-clear]');
      if (clearBtn) clearBtn.addEventListener('click', resetAll);
      if (cta) {
        cta.addEventListener('click', (e) => {
          e.preventDefault();
          const target = root.querySelector('#s6oh-products');
          if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        });
      }
      const moreBtn = root.querySelector('[data-s6oh-more-filters]');
      const extra = root.querySelector('[data-s6oh-extra-filters]');
      if (moreBtn && extra) {
        moreBtn.addEventListener('click', () => {
          const open = extra.hidden;
          extra.hidden = !open;
          moreBtn.setAttribute('aria-expanded', open);
        });
      }
    };
    const scanRect = (scope) => scope.querySelectorAll('.s6oh--rect').forEach(initRect);
    document.addEventListener('shopify:section:load', (event) => scanRect(event.target));
    scanRect(document);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s6-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.s6rvReady) return;
      root.dataset.s6rvReady = 'true';
      const track = root.querySelector('[data-s6rv-track]');
      const prev = root.querySelector('[data-s6rv-prev]');
      const next = root.querySelector('[data-s6rv-next]');
      const dotsEl = root.querySelector('[data-s6rv-dots]');
      if (!track) return;
      const items = () => Array.from(track.children).filter((el) => el.matches('.s6rv__card, .s6rv__extra'));
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let dots = [];
      const step = () => {
        const list = items();
        if (list.length < 2) return track.clientWidth;
        return list[1].offsetLeft - list[0].offsetLeft;
      };
      const index = () => Math.max(0, Math.min(items().length - 1, Math.round(track.scrollLeft / Math.max(1, step()))));
      const goTo = (i) => {
        const k = Math.max(0, Math.min(items().length - 1, i));
        track.scrollTo({ left: k * step(), behavior: reduce ? 'auto' : 'smooth' });
      };
      // number of distinct scroll positions (cards per view is 1 / 2 / 3 depending on width)
      const positions = () => {
        const n = items().length;
        const perView = Math.max(1, Math.round((track.clientWidth + 1) / Math.max(1, step())));
        return Math.max(1, n - perView + 1);
      };
      const buildDots = () => {
        if (!dotsEl) return;
        dotsEl.textContent = '';
        dots = [];
        const n = positions();
        items().slice(0, n).forEach((el, i) => {
          const d = document.createElement('button');
          d.type = 'button';
          d.className = 's6rv__dot';
          d.setAttribute('aria-label', String(i + 1) + ' / ' + n);
          d.addEventListener('click', () => goTo(i));
          dotsEl.appendChild(d);
          dots.push(d);
        });
      };
      const sync = () => {
        const scrollable = track.scrollWidth > track.clientWidth + 2;
        if (prev) prev.hidden = !scrollable;
        if (next) next.hidden = !scrollable;
        if (dotsEl) dotsEl.hidden = !scrollable;
        if (!scrollable) return;
        if (dots.length !== positions()) buildDots();
        const i = index();
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        dots.forEach((d, k) => d.setAttribute('aria-current', (atEnd ? k === dots.length - 1 : k === i) ? 'true' : 'false'));
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = atEnd;
      };
      let raf = 0;
      track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      if (prev) prev.addEventListener('click', () => goTo(index() - 1));
      if (next) next.addEventListener('click', () => goTo(index() + 1));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); }
      });
      sync();
      window.addEventListener('load', sync);

      // Autoplay (opt-in per section via data-s6rv-autoplay="<ms>"). Advances one card, wraps to the start at the end.
      // Stops for good after any manual interaction (arrow, dot, swipe, keyboard); pauses while hovered / focused,
      // while the tab is hidden or the slider is off-screen, and never runs with prefers-reduced-motion.
      const delay = parseInt(root.dataset.s6rvAutoplay || '', 10);
      if (delay > 0 && !reduce) {
        let timer = 0;
        let stopped = false;
        let hold = false;
        let visible = true;
        const tick = () => {
          if (stopped || hold || !visible || document.hidden) return;
          if (!(track.scrollWidth > track.clientWidth + 2)) return;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
          goTo(atEnd ? 0 : index() + 1);
        };
        const start = () => { clearInterval(timer); if (!stopped) timer = setInterval(tick, delay); };
        const stop = () => { stopped = true; clearInterval(timer); };
        ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((ev) => track.addEventListener(ev, stop, { passive: true }));
        [prev, next, dotsEl].forEach((el) => el && el.addEventListener('click', stop));
        const slider = root.querySelector('[data-s6rv-slider]') || track;
        slider.addEventListener('mouseenter', () => { hold = true; });
        slider.addEventListener('mouseleave', () => { hold = false; });
        slider.addEventListener('focusin', () => { hold = true; });
        slider.addEventListener('focusout', () => { hold = false; });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => { visible = entries.some((e) => e.isIntersecting); }, { threshold: 0.3 }).observe(root);
        }
        start();
      }
    };
    const scan = () => document.querySelectorAll('[data-s6-reviews]').forEach(init);
    scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
